import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { decodeToken } from "react-jwt";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";

import "./Styles/Clientes.scss";
import { getInfoCliente, getArchivosBIC, eliminarArchivoBIC, descargarArchivoBIC, eliminarArchivoFactura, getArchivosFactura, descargarArchivoFactura, eliminarArchivoPermiso, getArchivosPermiso, descargarArchivoPermiso, eliminarArchivoEscritura, getArchivosEscritura, descargarArchivoEscritura, eliminarArchivoConstancia, getArchivosConstancia, descargarArchivoConstancia, eliminarArchivoRegistro, getArchivosRegistro, descargarArchivoRegistro, eliminarArchivoEstados, getArchivosEstados, descargarArchivoEstados, GuardarInscripcion, GuardarAccionistas, getAccionistas, GuardarDirectores, getDirectores, eliminarArchivoRepresentante, getArchivoRepresentante, descargarArchivoRepresentante, eliminarArchivoRefComercial1, eliminarArchivoRefComercial2, getArchivoRefComercial1, getArchivoRefComercial2, eliminarArchivoRefBan1, getArchivoRefBan1, getArchivoRefBan2, eliminarArchivoRefBan2, eliminarArchivoCertificadoA, getArchivoCertificadoA, getArchivoCertificadoL, eliminarArchivoCertificadoL, eliminarArchivoFormatoInscripcion, getArchivoFormatoInscripcion, descargarArchivoFormatoInscripcion, descargarArchivoRefComercial1, descargarArchivoRefComercial2, descargarArchivoRefBan1, descargarArchivoRefBan2, descargarArchivoCertificadoA, descargarArchivoCertificadoL, guardarNombreFormato, eliminarNombreFormato, getTipoPagoCliente, DescargarManual } from "../../../Base/API/Clientes/ClientesRequest";
import { getCountriesList } from "../../API/Countries/CountriesRequest";
import { getTipoPago } from "../../API/Global/TiposPago/TipoPagosRequest";
import { Button } from "primereact/button";
import { SelectButton } from "primereact/selectbutton";
import { InscripcionClientesLang } from "../../../Base/Screens/Clientes/Lang/InscripcionClientesLang";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import Card from "../../../Base/Components/Card/Card";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { InputSwitch } from 'primereact/inputswitch';
import { useForm } from "../../../Base/Hooks/useForm";
import { downloadFile, uploadHandlerBIC, uploadHandlerCertificadoA, uploadHandlerCertificadoL, uploadHandlerConstancia, uploadHandlerEscritura, uploadHandlerEstados, uploadHandlerFactura, uploadHandlerFormatoInscripcion, uploadHandlerPermiso, uploadHandlerRefBanc1, uploadHandlerRefBanc2, uploadHandlerRefComercial1, uploadHandlerRefComercial2, uploadHandlerRegistro, uploadHandlerRepresentante } from '../../../Base/Services/ArchivosService';
import { toastShow } from "../../../Base/Services/ToastService";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import Loader from "../../../Base/Components/Loader/Loader";
import { getCorreosCliente, sendEmailInscripcion } from "../../../API/Global/Email/EmailRequest";
import { InputNumber } from "primereact/inputnumber";
import { InputMask } from "primereact/inputmask";
import { AuthContext } from "../../Context/AuthContext/AuthContext";
import { getCurrencyToken } from "../../API/Global/Currency/CurrencyRequest";
import { Dialog } from "primereact/dialog";
import DialogEstadoRevisadoClientes from './DialogEstadoRevisadoClientes'
import { Tag } from "primereact/tag";
import { getDateTimeString } from "../../Services/FechasService";
import { getDateTimeStringSQL24 } from "../../Services/Moment/Luxon";

const InscripcionClientes = () => {
  const { config, changeTheme } = useContext(ConfigContext);
  const navigate = useNavigate();
  const { userAuth } = useContext(AuthContext);
  const params = useParams();
  const Token = params.Token;
  const lang = params.lang !== "null" ? params.lang : "es";
  const toast = useRef(null);
  const fileUpload = useRef(null);
  const IdHonduras = 95;

  const [tokenInfo, setTokenInfo] = useState(null);
  const [showMessages, setShowMessages] = useState({ error: false });
  const [editable, setEditable] = useState(true);
  const [idCustomer, setIdCustomer] = useState(null);
  const [cliente, setCliente] = useState([]);
  const [idioma, setIdioma] = useState("es");
  const [loading, setLoading] = useState(false);
  const [Countries, setCountries] = useState([]);
  const [tipoPagos, setTipoPagos] = useState([]);
  const [moneda, setMonedas] = useState([]);
  const [ArchivoSelected, setArchivoSelected] = useState(0);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogIncompleto, setShowDialogIncompleto] = useState(false);
  const [correos, setCorreos] = useState('');
  const [tipoPagoClientes, setTipoPagoClientes] = useState([]);

  // ARCHIVOS
  const [listadoArchivos, setListadoArchivos] = useState([]);
  const [listadoArchivosFactura, setListadoArchivosFactura] = useState([]);
  const [listadoArchivosPermiso, setListadoArchivosPermiso] = useState([]);
  const [listadoArchivosEscritura, setListadoArchivosEscritura] = useState([]);
  const [listadoArchivosConstancia, setListadoArchivosConstancia] = useState([]);
  const [listadoArchivosRegistro, setListadoArchivosRegistro] = useState([]);
  const [listadoArchivosEstados, setListadoArchivosEstados] = useState([]);
  const [listadoAccionistas, setListadoAccionistas] = useState([]);
  const [listadoDirectores, setListadoDirectores] = useState([]);
  const [listadoArchivoRepresentante, setListadoArchivoRepresentante] = useState([]);
  const [listadoArchivoRefComercial1, setListadoArchivoRefComercial1] = useState([]);
  const [listadoArchivoRefComercial2, setListadoArchivoRefComercial2] = useState([]);
  const [listadoArchivoRefBanc1, setListadoArchivoRefBanc1] = useState([]);
  const [listadoArchivoRefBanc2, setListadoArchivoRefBanc2] = useState([]);
  const [listadoArchivoCertificadoA, setListadoArchivoCertificadoA] = useState([]);
  const [listadoArchivoCertificadoL, setListadoArchivoCertificadoL] = useState([]);
  const [listadoArchivoFormatoInscripcion, setListadoArchivoFormatoInscripcion] = useState([]);
  const [habilitarCredito, setHabilitarCredito] = useState(false);
  const [showDialogFinal, setShowDialogFinal] = useState(false);
  const [listaFaltantes, setListaFaltantes] = useState([]);

  const [dialogEstadoRevision, setDialogEstadoRevision] = useState(false)

  const handleCheckboxChange = (e) => {
    setHabilitarCredito(e.checked);
    verificarCampos(false, e.checked)
  };

  const [loadingCorreo, setLoadingCorreo] = useState(false);

  const initialValues = {
    IdRegistro: -1,
    PorcentajeParticipacion: null,
  };

  const { values, handleInputChange, setValues } = useForm(initialValues);


  const verificarCampos = (boton = false, checked, zonaLibre = false) => {
    let errors = {};
    let isValid = true;

    // INFOREMACION GENERAL
    if (!values.CustomerName) {
      errors.CustomerName = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.RTN) {
      errors.RTN = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Country) {
      errors.Country = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.State) {
      errors.State = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.City) {
      errors.City = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Address) {
      errors.Address = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Tel) {
      errors.Tel = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Email) {
      errors.Email = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.PrincipalActividadEconomica) {
      errors.PrincipalActividadEconomica = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.TipoPagos) {
      errors.TipoPagos = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Nombre) {
      errors.TipoPagosCliente = true;
      errors.General = true;
      isValid = false;
    }


    // INFOREMACION REPRESENTANTE LEGAL
    if (!values.NombreRepresentanteLegal) {
      errors.NombreRepresentanteLegal = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.CorreoRepresentante) {
      errors.CorreoRepresentante = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.TelefonoRepresentante) {
      errors.TelefonoRepresentante = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.IdentificacionRepresentante) {
      errors.IdentificacionRepresentante = true;
      errors.General = true;
      isValid = false;
    }
    if (listadoArchivoRepresentante?.length <= 0) {
      errors.FileRepresentante = true;
      isValid = false;
    }


    if (checked !== undefined) {
      if (checked === true) {
        if (listadoAccionistas?.length <= 0) {
          errors.ErrorAccionistas = true;
          errors.General = true;
          isValid = false;
        }

        //DIRECTORES
        if (listadoDirectores?.length <= 0) {
          errors.ErrorDirectores = true;
          errors.General = true;
          isValid = false;
        }

        // INFOREMACION REFERENCIA
        if (!values.CompanyRefComercial1) {
          errors.CompanyRefComercial1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.CompanyRefComercial2) {
          errors.CompanyRefComercial2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefNombre1) {
          errors.RefNombre1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefNombre2) {
          errors.RefNombre2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefTelefono1) {
          errors.RefTelefono1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefTelefono2) {
          errors.RefTelefono2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefCorreo1) {
          errors.RefCorreo1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefCorreo2) {
          errors.RefCorreo2 = true;
          errors.General = true;
          isValid = false;
        }
        if (listadoArchivoRefComercial1?.length <= 0) {
          errors.FileRefComercial1 = true;
          isValid = false;
        }
        if (listadoArchivoRefComercial2?.length <= 0) {
          errors.FileRefComercial2 = true;
          isValid = false;
        }


        //REFERENCIAS BANCARIAS
        if (!values.BankName1) {
          errors.BankName1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.BankName2) {
          errors.BankName2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.NombreRefBancaria1) {
          errors.NombreRefBancaria1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.NombreRefBancaria2) {
          errors.NombreRefBancaria2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.TelefonoRefBancaria1) {
          errors.TelefonoRefBancaria1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.TelefonoRefBancaria2) {
          errors.TelefonoRefBancaria2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.CorreoRefBancaria1) {
          errors.CorreoRefBancaria1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.CorreoRefBancaria2) {
          errors.CorreoRefBancaria2 = true;
          errors.General = true;
          isValid = false;
        }
        if (listadoArchivoRefBanc1?.length <= 0) {
          errors.FileRefBanc1 = true;
          isValid = false;
        }
        if (listadoArchivoRefBanc2?.length <= 0) {
          errors.FileRefBanc2 = true;
          isValid = false;
        }

        if ((listadoArchivosFactura?.length <= 0 || !listadoArchivosFactura?.length)) {
          errors.FileFactura = true;
          isValid = false;
        }
        if (listadoArchivosEstados?.length <= 0) {
          errors.FileEstadosFinancieros = true;
          isValid = false;
        }
        if ((listadoArchivosEscritura?.length <= 0 || !listadoArchivosEscritura?.length)) {
          errors.FileConstitucion = true;
          isValid = false;
        }
      } else {
        setValues({
          ...values,
        })

        delete errors.ErrorDirectores;
        delete errors.FileConstitucion;
        delete errors.FileEstadosFinancieros;
        delete errors.FileFactura;
        delete errors.FileRefBanc1;
        delete errors.FileRefBanc2;
        delete errors.FileRefComercial1;
        delete errors.FileRefComercial2;
        delete errors.General;

      }
    } else {
      if (habilitarCredito) {
        //ACCIONISTAS
        if (listadoAccionistas?.length <= 0) {
          errors.ErrorAccionistas = true;
          errors.General = true;
          isValid = false;
        }

        //DIRECTORES
        if (listadoDirectores?.length <= 0) {
          errors.ErrorDirectores = true;
          errors.General = true;
          isValid = false;
        }

        // INFOREMACION REFERENCIA
        if (!values.CompanyRefComercial1) {
          errors.CompanyRefComercial1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.CompanyRefComercial2) {
          errors.CompanyRefComercial2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefNombre1) {
          errors.RefNombre1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefNombre2) {
          errors.RefNombre2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefTelefono1) {
          errors.RefTelefono1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefTelefono2) {
          errors.RefTelefono2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefCorreo1) {
          errors.RefCorreo1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefCorreo2) {
          errors.RefCorreo2 = true;
          errors.General = true;
          isValid = false;
        }
        if (listadoArchivoRefComercial1?.length <= 0) {
          errors.FileRefComercial1 = true;
          isValid = false;
        }
        if (listadoArchivoRefComercial2?.length <= 0) {
          errors.FileRefComercial2 = true;
          isValid = false;
        }


        //REFERENCIAS BANCARIAS
        if (!values.BankName1) {
          errors.BankName1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.BankName2) {
          errors.BankName2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.NombreRefBancaria1) {
          errors.NombreRefBancaria1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.NombreRefBancaria2) {
          errors.NombreRefBancaria2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.TelefonoRefBancaria1) {
          errors.TelefonoRefBancaria1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.TelefonoRefBancaria2) {
          errors.TelefonoRefBancaria2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.CorreoRefBancaria1) {
          errors.CorreoRefBancaria1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.CorreoRefBancaria2) {
          errors.CorreoRefBancaria2 = true;
          errors.General = true;
          isValid = false;
        }
        if (listadoArchivoRefBanc1?.length <= 0) {
          errors.FileRefBanc1 = true;
          isValid = false;
        }
        if (listadoArchivoRefBanc2?.length <= 0) {
          errors.FileRefBanc2 = true;
          isValid = false;
        }

        if ((listadoArchivosFactura?.length <= 0 || !listadoArchivosFactura?.length)) {
          errors.FileFactura = true;
          isValid = false;
        }
        if (listadoArchivosEstados?.length <= 0) {
          errors.FileEstadosFinancieros = true;
          isValid = false;
        }
        if ((listadoArchivosEscritura?.length <= 0 || !listadoArchivosEscritura?.length)) {
          errors.FileConstitucion = true;
          isValid = false;
        }

      }
    }

    if (habilitarCredito) {
      //ACCIONISTAS
      if (listadoAccionistas?.length <= 0) {
        errors.ErrorAccionistas = true;
        errors.General = true;
        isValid = false;
      }

      //DIRECTORES
      if (listadoDirectores?.length <= 0) {
        errors.ErrorDirectores = true;
        errors.General = true;
        isValid = false;
      }

      // INFOREMACION REFERENCIA
      if (!values.CompanyRefComercial1) {
        errors.CompanyRefComercial1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.CompanyRefComercial2) {
        errors.CompanyRefComercial2 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.RefNombre1) {
        errors.RefNombre1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.RefNombre2) {
        errors.RefNombre2 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.RefTelefono1) {
        errors.RefTelefono1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.RefTelefono2) {
        errors.RefTelefono2 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.RefCorreo1) {
        errors.RefCorreo1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.RefCorreo2) {
        errors.RefCorreo2 = true;
        errors.General = true;
        isValid = false;
      }
      if (listadoArchivoRefComercial1?.length <= 0) {
        errors.FileRefComercial1 = true;
        isValid = false;
      }
      if (listadoArchivoRefComercial2?.length <= 0) {
        errors.FileRefComercial2 = true;
        isValid = false;
      }


      //REFERENCIAS BANCARIAS
      if (!values.BankName1) {
        errors.BankName1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.BankName2) {
        errors.BankName2 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.NombreRefBancaria1) {
        errors.NombreRefBancaria1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.NombreRefBancaria2) {
        errors.NombreRefBancaria2 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.TelefonoRefBancaria1) {
        errors.TelefonoRefBancaria1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.TelefonoRefBancaria2) {
        errors.TelefonoRefBancaria2 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.CorreoRefBancaria1) {
        errors.CorreoRefBancaria1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.CorreoRefBancaria2) {
        errors.CorreoRefBancaria2 = true;
        errors.General = true;
        isValid = false;
      }
      if (listadoArchivoRefBanc1?.length <= 0) {
        errors.FileRefBanc1 = true;
        isValid = false;
      }
      if (listadoArchivoRefBanc2?.length <= 0) {
        errors.FileRefBanc2 = true;
        isValid = false;
      }

      if ((listadoArchivosFactura?.length <= 0 || !listadoArchivosFactura?.length)) {
        errors.FileFactura = true;
        isValid = false;
      }
      if (listadoArchivosEstados?.length <= 0) {
        errors.FileEstadosFinancieros = true;
        isValid = false;
      }
      if ((listadoArchivosEscritura?.length <= 0 || !listadoArchivosEscritura?.length)) {
        errors.FileConstitucion = true;
        isValid = false;
      }

    }


    // INFOREMACION CUENTAS POR PAGAR
    if (!values.ContactoCuentasPorPagar) {
      errors.ContactoCuentasPorPagar = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.CorreoCuentasPorPagar) {
      errors.CorreoCuentasPorPagar = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.TelefonoCuentasPorPagar) {
      errors.TelefonoCuentasPorPagar = true;
      errors.General = true;
      isValid = false;
    }

    // INFOREMACION CONTACTO FINANZAS
    if (!values.NombreContactoFin1) {
      errors.NombreContactoFin1 = true;
      errors.General = true;
      isValid = false;
    }
    // if (!values.NombreContactoFin2) {
    //   errors.NombreContactoFin2 = true;
    //   errors.General = true;
    //   isValid = false;
    // }
    if (!values.CorreoContactoFin1) {
      errors.CorreoContactoFin1 = true;
      errors.General = true;
      isValid = false;
    }
    // if (!values.CorreoContactoFin2) {
    //   errors.CorreoContactoFin2 = true;
    //   errors.General = true;
    //   isValid = false;
    // }
    if (!values.TelefonoContactoFin1) {
      errors.TelefonoContactoFin1 = true;
      errors.General = true;
      isValid = false;
    }
    // if (!values.TelefonoContactoFin2) {
    //   errors.TelefonoContactoFin2 = true;
    //   errors.General = true;
    //   isValid = false;
    // }

    if (!values.Autorizacion) {
      errors.Autorizacion = true;
      isValid = false;
    }

    if ((listadoArchivos?.length <= 0 || !listadoArchivos?.length)) {
      errors.FileBIC = true;
      isValid = false;
    }

    if ((listadoArchivosPermiso?.length <= 0 || !listadoArchivosPermiso?.length)) {
      errors.FilePermisoOpera = true;
      isValid = false;
    }

    if (zonaLibre !== undefined) {
      if (ArchivoSelected === 1) {
        if (!values.NombreZonaLibre) {
          errors.NombreZonaLibre = true;
          isValid = false;
        }
        if ((listadoArchivosRegistro?.length <= 0 || !listadoArchivosRegistro?.length)) {
          errors.FileRegistroExonerado = true;
          isValid = false;
        }
      } else {
        // console.log("acaaaaaaaaaaaa")
      }
    } else {
      // console.log("else 1")
    }

    if (ArchivoSelected === 1 || zonaLibre) {
      if (ArchivoSelected === 1) {

      } else {

      }
      // if(ArchivoSelected === 0){
      //   if (!values.NombreZonaLibre) {
      //     errors.NombreZonaLibre = true;
      //     isValid = false;
      //   }
      //   if ((listadoArchivosRegistro?.length <= 0 || !listadoArchivosRegistro?.length)) {
      //     errors.FileRegistroExonerado = true;
      //     isValid = false;
      //   }
      // }
    }

    setShowMessages({ ...errors, error: !isValid });


    const mensajesErrores = {
      CustomerName: "Nombre Cliente",
      RTN: "BIC: RTN/NIT/RUC/TAX ID",
      Country: "País",
      State: "Estado",
      City: "Ciudad",
      Address: "Dirección",
      Tel: "Teléfono",
      Email: "Correo electrónico",
      PrincipalActividadEconomica: "Actividad económica principal",
      TipoPagos: "Método de pago",
      NombreRepresentanteLegal: "Información del representante legal",
      CorreoRepresentante: "Correo del representante legal",
      TelefonoRepresentante: "Teléfono del representante legal",
      IdentificacionRepresentante: "Identificación del representante legal",
      FileRepresentante: "Archivo del representante legal",
      ContactoCuentasPorPagar: "Información de cuentas por pagar",
      CorreoCuentasPorPagar: "Correo de cuentas por pagar",
      TelefonoCuentasPorPagar: "Teléfono de cuentas por pagar",
      NombreContactoFin1: "Información de contacto financiero 1",
      CorreoContactoFin1: "Correo de contacto financiero 1",
      TelefonoContactoFin1: "Teléfono de contacto financiero 1",
      ErrorAccionistas: "Información de los accionistas",
      ErrorDirectores: "Información de los directores",

      CompanyRefComercial1: "Información de referencias comerciales 1",
      CompanyRefComercial2: "Información de referencias comerciales 2",
      RefNombre1: "Nombre de referencia comercial 1",
      RefNombre2: "Nombre de referencia comercial 2",
      RefCorreo1: "Correo de referencia comercial 1",
      RefCorreo2: "Correo de referencia comercial 2",
      RefTelefono1: "Teléfono de referencia comercial 1",
      RefTelefono2: "Teléfono de referencia comercial 2",
      FileRefComercial1: "Archivo de referencia comercial 1",
      FileRefComercial2: "Archivo de referencia comercial 2",

      BankName1: 'Información de referencias bancarias 1',
      BankName2: 'Información de referencias bancarias 2',
      NombreRefBancaria1: "Nombre de referencia bancaria 1",
      NombreRefBancaria2: "Nombre de referencia bancaria 2",
      TelefonoRefBancaria1: "Teléfono de referencia bancaria 1",
      TelefonoRefBancaria2: "Teléfono de referencia bancaria 2",
      CorreoRefBancaria1: "Correo de referencia bancaria 1",
      CorreoRefBancaria2: "Correo de referencia bancaria 2",
      FileRefBanc1: "Archivo de referencia bancaria 1",
      FileRefBanc2: "Archivo de referencia bancaria 2",

      FileBIC: "Archivo BIC: RTN/NIT/RUC/TAX ID",
      FileFactura: "Archivo de factura/orden de compra/dirección",
      FileEstadosFinancieros: "Archivo de estado financiero",
      FilePermisoOpera: "Archivo de permiso de operaciones",
      FileConstitucion: "Archivo de escritura de la constitución",
      FileRegistroExonerado: "Archivo de registro exonerado",
      General: '',
      NombreZonaLibre: 'Nombre de Zona Libre.'
    };

    const mensajesErroresEN = {
      CustomerName: "Customer Name",
      RTN: "BIC: RTN/NIT/RUC/TAX ID",
      Country: "Country",
      State: "State",
      City: "City",
      Address: "Address",
      Tel: "Phone",
      Email: "Email",
      PrincipalActividadEconomica: "Main Economic Activity",
      TipoPagos: "Payment Method",
      NombreRepresentanteLegal: "Legal Representative Information",
      CorreoRepresentante: "Legal Representative Email",
      TelefonoRepresentante: "Legal Representative Phone",
      IdentificacionRepresentante: "Legal Representative ID",
      FileRepresentante: "Legal Representative File",
      ContactoCuentasPorPagar: "Accounts Payable Contact Information",
      CorreoCuentasPorPagar: "Accounts Payable Email",
      TelefonoCuentasPorPagar: "Accounts Payable Phone",
      NombreContactoFin1: "Finance Contact Information 1",
      CorreoContactoFin1: "Finance Contact Email 1",
      TelefonoContactoFin1: "Finance Contact Phone 1",
      ErrorAccionistas: "Shareholders Information",
      ErrorDirectores: "Directors Information",

      BankName1: 'Bank Reference Information 1',
      BankName2: 'Bank Reference Information 2',
      CompanyRefComercial1: "Commercial Reference Information 1",
      CompanyRefComercial2: "Commercial Reference Information 2",
      RefNombre1: "Commercial Reference Name 1",
      RefNombre2: "Commercial Reference Name 2",
      RefCorreo1: "Commercial Reference Email 1",
      RefCorreo2: "Commercial Reference Email 2",
      RefTelefono1: "Commercial Reference Phone 1",
      RefTelefono2: "Commercial Reference Phone 2",
      FileRefComercial1: "Commercial Reference File 1",
      FileRefComercial2: "Commercial Reference File 2",

      NombreRefBancaria1: "Bank Reference Name 1",
      NombreRefBancaria2: "Bank Reference Name 2",
      TelefonoRefBancaria1: "Bank Reference Phone 1",
      TelefonoRefBancaria2: "Bank Reference Phone 2",
      CorreoRefBancaria1: "Bank Reference Email 1",
      CorreoRefBancaria2: "Bank Reference Email 2",
      FileRefBanc1: "Bank Reference File 1",
      FileRefBanc2: "Bank Reference File 2",

      FileBIC: "BIC: RTN/NIT/RUC/TAX ID",
      FileFactura: "Invoice/Purchase Order/Address File",
      FileEstadosFinancieros: "Financial Statement File",
      FilePermisoOpera: "Operating Permit File",
      FileConstitucion: "Constitution Deed File",
      FileRegistroExonerado: "Exonerated Registration File",
      General: '',
      NombreZonaLibre: 'Free Zone Name'
    };


    const listaFaltantes = Object.keys(errors).filter(key => errors[key]).map(key => (idioma === 'es' ? mensajesErrores[key] : mensajesErroresEN[key]) || '');
    setListaFaltantes(listaFaltantes, errors);



    // console.log(errors);
    if (boton) {
      if (errors !== {} && isValid) {
        setShowDialog(true);
      } else {
        const totalPorcentaje = listadoAccionistas.reduce((acc, accionista) => acc + (accionista.PorcentajeParticipacion || 0), 0);

        if (totalPorcentaje !== 100 && (habilitarCredito || checked)) {
          toastShow(toast, 'warn', 'Error', 'La suma de los porcentajes de participación debe ser igual al 100%');
        }

        setShowDialogIncompleto(true);
      }
    }


  }

  const getCompanyInfo = async (IdCustomer) => {
    setLoading(true);

    const result = await getInfoCliente(IdCustomer, Token);

    setCliente(result);

    const accionistasTempo = await getAccionistas(IdCustomer, Token);
    setListadoAccionistas(accionistasTempo)

    const directoresTempo = await getDirectores(IdCustomer, Token);
    setListadoDirectores(directoresTempo)

    const tempoTipoPagos = await getTipoPagoCliente(Token);
    setTipoPagoClientes(tempoTipoPagos)

    if (result?.length > 0) {
      //PAISES
      const contriesT = await getCountriesList(Token);
      const pais = contriesT?.find((x) => x.Id === result[0]?.IdCountry);

      //TIPO FACTURA
      const tipoFacturaT = await getTipoPago(Token);
      const factura = tipoFacturaT.find(
        (t) => t.IdTipoPago === result[0]?.TipoFacturacion
      );

      //TIPO FACTURA
      const tipoPagoT = await getTipoPagoCliente(Token);
      const pago = tipoPagoT.find(
        (t) => t.IdTipoPago === result[0]?.IdTipoPagoCliente
      );

      //Monedas
      const moneda = await getCurrencyToken(Token);
      const money = moneda.find(
        (m) => m.IdCurrency === result[0]?.IdCurrency
      );
      setEditable(result[0]?.esEditable)

      setValues({
        ...result[0],
        Country: pais,
        TipoPagos: factura,
        Currencies: money,
        Nombre: pago,
        RTN: result[0]?.RTN
      });
      setArchivoSelected(result[0]?.ZonaLibre ? 1 : 0)

      const archivo = await getArchivosBIC(result[0]?.CodigoCliente, Token);
      setListadoArchivos(archivo);

      const archivoFactura = await getArchivosFactura(result[0]?.CodigoCliente, Token);
      setListadoArchivosFactura(archivoFactura);

      const archivoEstado = await getArchivosEstados(result[0]?.CodigoCliente, Token);
      setListadoArchivosEstados(archivoEstado);

      const archivoPermiso = await getArchivosPermiso(result[0]?.CodigoCliente, Token);
      setListadoArchivosPermiso(archivoPermiso);

      const archivoEscritura = await getArchivosEscritura(result[0]?.CodigoCliente, Token);
      setListadoArchivosEscritura(archivoEscritura);

      const archivoConstancia = await getArchivosConstancia(result[0]?.CodigoCliente, Token);
      setListadoArchivosConstancia(archivoConstancia);

      const archivoRegistro = await getArchivosRegistro(result[0]?.CodigoCliente, Token);
      setListadoArchivosRegistro(archivoRegistro);

      const archivoRepresentante = await getArchivoRepresentante(result[0]?.CodigoCliente, Token);
      setListadoArchivoRepresentante(archivoRepresentante);

      const archivoRefComercial1 = await getArchivoRefComercial1(result[0]?.CodigoCliente, Token);
      setListadoArchivoRefComercial1(archivoRefComercial1);

      const archivoRefComercial2 = await getArchivoRefComercial2(result[0]?.CodigoCliente, Token);
      setListadoArchivoRefComercial2(archivoRefComercial2);

      const archivoRefBanc1 = await getArchivoRefBan1(result[0]?.CodigoCliente, Token);
      setListadoArchivoRefBanc1(archivoRefBanc1);

      const archivoRefBanc2 = await getArchivoRefBan2(result[0]?.CodigoCliente, Token);
      setListadoArchivoRefBanc2(archivoRefBanc2);

      const archivoCertificadoA = await getArchivoCertificadoA(result[0]?.CodigoCliente, Token);
      setListadoArchivoCertificadoA(archivoCertificadoA);

      const archivoCertificadoL = await getArchivoCertificadoL(result[0]?.CodigoCliente, Token);
      setListadoArchivoCertificadoL(archivoCertificadoL);

      const archivoFormato = await getArchivoFormatoInscripcion(result[0]?.CodigoCliente, Token);
      setListadoArchivoFormatoInscripcion(archivoFormato);
    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const hideDialogRevision = () => {
    setDialogEstadoRevision(false)
    getCompanyInfo(values.IdCustomer)
  }

  const getInfo = async () => {
    const result = await getInfoCliente(idCustomer, Token);
    setCliente(result);

    const contriesT = await getCountriesList(Token);
    setCountries(contriesT);

    const tipoFacturaT = await getTipoPago(Token);
    setTipoPagos(tipoFacturaT);

    const envioCorreos = await getCorreosCliente(Token)
    setCorreos(envioCorreos);

    const tempoTipoPagos = await getTipoPagoCliente(Token);
    setTipoPagoClientes(tempoTipoPagos)

    //Monedas
    const moneda = await getCurrencyToken(Token);
    setMonedas(moneda);
  };

  const EnviarCorreoConfimacion = async () => {
    setLoadingCorreo(true);
    setTimeout(async () => {
      const cliente = {
        nombre: values.CustomerName,
        codigo: values.CodigoCliente,
      };

      const htmlContent = `
        <div>
          <h4>Notificación de Actualización de Información del Cliente</h4>
          <p>El cliente <strong>${cliente.nombre}</strong>, con Códido de Cliente <strong>${cliente.codigo}</strong> ha actualizado su información.</p>
          <p>Por favor, revise la nueva información en el sistema.</p>
          <p>*Correo generado automáticamente, por favor no responder.</p>
          <p>Saludos cordiales.</p>
        </div>
      `;

      const objeto = {
        to: correos[0].DestinatariosMail,
        cc: correos[0].CCMail,
        bcc: correos[0].CCoMail,
        subject: correos[0].Asunto,
        html: htmlContent,
      };

      const result = await sendEmailInscripcion(objeto, Token);

      setLoadingCorreo(false);
    }, 1000);
    setLoadingCorreo(false);
  };

  const guardarInscripcion = async (Incompleta = false) => {
    setLoading(true);
    verificarCampos();

    const BIC = getArchivos();
    const ArchivoBIC = await BIC.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const PERM = getArchivosPerm();
    const ArchivoPERM = await PERM.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const FACT = getArchivosFact();
    const ArchivoFACT = await FACT.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const ESC = getArchivosEsc();
    const ArchivoESC = await ESC.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const CONS = getArchivosCons();
    const ArchivoCONS = await CONS.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const REG = getArchivosReg();
    const ArchivoREG = await REG.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const EST = getArchivosEst();
    const ArchivoEST = await EST.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const REP = getArchivosRepresentante();
    const ArchivoREP = await REP.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const REF1 = getArchivosRefComercial1();
    const ArchivoREF1 = await REF1.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const REF2 = getArchivosRefComercial2();
    const ArchivoREF2 = await REF2.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const BAN1 = getArchivosRefBanc1();
    const ArchivoBAN1 = await BAN1.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const BAN2 = getArchivosRefBanc2();
    const ArchivoBAN2 = await BAN2.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const CAMB = getArchivosCertificadoA();
    const ArchivoCAMB = await CAMB.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const CLAB = getArchivosCertificadoL();
    const ArchivoCLAB = await CLAB.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');



    if (ArchivoSelected === 1) {
      eliminarConstanciaSinToast(values?.FileConstanciaPagosCuenta);
    } else {
      eliminarRegistroSinToast(values?.FileRegistroExonerado);
    }

    setLoading(true);


    const Datos = {
      IdRegistro: values?.IdRegistro,
      IdCustomer: values?.IdCustomer,
      RTN: values?.RTN,
      CustomerName: values?.CustomerName,
      IdCountry: values?.Country.Id,
      State: values?.State,
      City: values?.City,
      Address: values?.Address,
      Tel: values?.Tel,
      Email: values?.Email,
      PrincipalActividadEconomica: values?.PrincipalActividadEconomica,
      IdTipoPagoCliente: habilitarCredito ? 2 : 1,
      TipoFacturacion: values?.TipoPagos?.IdTipoPago,
      CasaMatriz: values?.CasaMatriz,
      DireccionCasaMatriz: values?.DireccionCasaMatriz,
      NombreRepresentanteLegal: values?.NombreRepresentanteLegal,
      CorreoRepresentanteLegal: values?.CorreoRepresentante,
      ContactoCuentasPorPagar: values?.ContactoCuentasPorPagar,
      CorreoCuentasPorPagar: values?.CorreoCuentasPorPagar,
      TelefonoCuentasPorPagar: values?.TelefonoCuentasPorPagar,
      NombreContactoFin1: values?.NombreContactoFin1,
      CorreoContactoFin1: values?.CorreoContactoFin1,
      TelefonoContactoFin1: values?.TelefonoContactoFin1,
      // NombreContactoFin2: values?.NombreContactoFin2,
      // CorreoContactoFin2: values?.CorreoContactoFin2,
      TelefonoContactoFin2: values?.TelefonoContactoFin2,
      RefNombre1: values?.RefNombre1,
      RefCorreo1: values?.RefCorreo1,
      RefTelefono1: values?.RefTelefono1,
      RefNombre2: values?.RefNombre2,
      RefCorreo2: values?.RefCorreo2,
      RefTelefono2: values?.RefTelefono2,
      RefNombre3: values?.RefNombre3,
      RefCorreo3: values?.RefCorreo3,
      RefTelefono3: values?.RefTelefono3,
      FileBIC: ArchivoBIC,
      FileFactura: ArchivoFACT,
      FilePermisoOpera: ArchivoPERM,
      FileConstitucion: ArchivoESC,
      ZonaLibre: ArchivoSelected === 1,
      NombreZonaLibre: ArchivoSelected === 1 ? values?.NombreZonaLibre : null,
      DireccionZonaLibre: ArchivoSelected === 1 ? values?.DireccionZonaLibre : null,
      FileConstanciaPagosCuenta: ArchivoSelected === 0 ? ArchivoCONS : null,
      FileRegistroExonerado: ArchivoSelected === 1 ? ArchivoREG : null,
      FileEstadosFinancieros: ArchivoEST,
      Autorizacion: values?.Autorizacion,
      IdCurrency: values?.Currencies?.IdCurrency,
      ActivosCorrientes: values?.ActivosCorrientes,
      TotalActivos: values?.TotalActivos,
      PasivosCorrientes: values?.PasivosCorrientes,
      TotalPasivos: values?.TotalPasivos,

      //REPRESENTANTE
      FileRepresentante: ArchivoREP,
      TelefonoRepresentante: values?.TelefonoRepresentante,
      IdentificacionRepresentante: values?.IdentificacionRepresentante,

      //REFERENCIAS ARCHIVOS
      CompanyRefComercial1: values?.CompanyRefComercial1,
      CompanyRefComercial2: values?.CompanyRefComercial2,
      FileRefComercial1: ArchivoREF1,
      FileRefComercial2: ArchivoREF2,

      //REFERENCIAS BANCARIAS
      BankName1: values?.BankName1,
      BankName2: values?.BankName2,
      NombreRefBancaria1: values?.NombreRefBancaria1,
      NombreRefBancaria2: values?.NombreRefBancaria2,
      TelefonoRefBancaria1: values?.TelefonoRefBancaria1,
      TelefonoRefBancaria2: values?.TelefonoRefBancaria2,
      CorreoRefBancaria1: values?.CorreoRefBancaria1,
      CorreoRefBancaria2: values?.CorreoRefBancaria2,
      FileRefBanc1: ArchivoBAN1,
      FileRefBanc2: ArchivoBAN2,

      //OTROS DOC
      FileCertificadoAmbiental: ArchivoCAMB,
      FileCertificadoLaboral: ArchivoCLAB,

      //NUEVOS CAMPOS
      // InvoicesToBe: values?.InvoicesToBe,
      // BilledToAddress: values?.BilledToAddress,
      Incompleta: Incompleta,
      FechaFormatoCompletado: !Incompleta ? getDateTimeStringSQL24(new Date()) : values?.FechaFormatoCompletado,
      Token: Token,
    };

    const DatosAccionistas = listadoAccionistas.map(accionista => ({
      ...accionista,
      Email: accionista?.EmailAccionista,
      IdCustomer: values?.IdCustomer,
      IdTipo: 1
    }));

    const DatosDirectores = listadoDirectores.map(director => ({
      ...director,
      Email: director?.EmailDirector,
      NombreAccionista: director?.NombreDirector,
      Posicion: director?.Posicion,
      IdentificacionAccionista: director?.IdentificacionDirector,
      IdCustomer: values?.IdCustomer,
      IdTipo: 2
    }));

    setLoading(true)

    const resultado = await GuardarInscripcion(Datos, Token)


    if (habilitarCredito) {
      const res = await GuardarAccionistas(DatosAccionistas, Token)
      const res2 = await GuardarDirectores(DatosDirectores, Token)
    }


    if (resultado[0]?.ESTADO === 1) {
      toastShow(toast, "success", "Datos Agregados", resultado[0]?.MENSAJE);

      getInfo()
      if (!Incompleta) {
        EnviarCorreoConfimacion();
        if (habilitarCredito) {
          setShowDialogFinal(true)
        }
        confirmDialog({
          header: setLabel('InscripcionFinalizada'),
          message: setLabel('msgCompleta'),
          rejectLabel: ' ',
          acceptLabel: 'Cerrar',
        })
        setTimeout(() => {
          setLoading(false)
          setEditable(false);
        }, 1300);
      } else {
        confirmDialog({
          header: setLabel('InscripcionFinalizada'),
          message: setLabel('msgNoEditableIncompleta'),
          rejectLabel: ' ',
          acceptLabel: 'Cerrar',
        })
        setShowDialogIncompleto(false)
        setTimeout(() => {
          setLoading(false)
          setEditable(true);
        }, 1300);
        setTimeout(() => {
          toastShow(toast, "warn", "Información Agregada", "Agregue los campos requeridos para completar la inscripción.");
        }, 500);
      }
    } else {
      toastShow(
        toast,
        "error",
        "Error",
        resultado[0]?.MENSAJE
      );
      setLoading(false)
    }

    setLoading(false);
    setShowDialog(false);
  }

  const setLabel = (label) => {
    return getLabel(InscripcionClientesLang, label, idioma);
  };

  const referencia = {
    IdRef: idCustomer,
    Codigo: values?.CodigoCliente,
    CustomerName: values?.CustomerName
  };

  //---------------------------------------------------------------------------------- SUBIR ARCHIVOS -------------------------------------------------------------------------------------

  const subirFileBIC = async (e) => {
    // const result = await getInfoCliente(idCustomer, Token);
    if (listadoArchivos?.length >= 1) {
      if (toast) {
        toastShow(
          toast,
          "error",
          "Error",
          "Solo se permite subir 1 archivo. Elimine el Archivo anterior"
        );
      }
    } else {
      // if (result[0]?.FileBIC !== null) {
      //   await eliminarArchivoBIC(
      //     result[0]?.CodigoCliente,
      //     result[0]?.FileBIC,
      //     Token
      //   );
      // }
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerBIC({ e, inputs, toast, ref: fileUpload, Token });
      getArchivos(true)
    }

  };

  const subirFileFactura = async (e) => {
    // const result = await getInfoCliente(idCustomer, Token);

    if (listadoArchivosFactura?.length >= 1) {
      if (toast) {
        toastShow(
          toast,
          "error",
          "Error",
          "Solo se permite subir 1 archivo. Elimine el Archivo anterior"
        );
      }
    } else {
      // if(result[0]?.FileFactura !== null){
      //   await eliminarArchivoFactura(result[0]?.CodigoCliente ,result[0]?.FileFactura)
      // }

      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerFactura({ e, inputs, toast, ref: fileUpload, Token });
      getArchivosFact(true);
    }

  };

  const subirFilePermiso = async (e) => {
    // const result = await getInfoCliente(idCustomer, Token);

    if (listadoArchivosPermiso?.length >= 1) {
      if (toast) {
        toastShow(
          toast,
          "error",
          "Error",
          "Solo se permite subir 1 archivo. Elimine el Archivo anterior"
        );
      }
    } else {
      // if(result[0]?.FilePermisoOpera !== null){
      //   await eliminarArchivoPermiso(result[0]?.CodigoCliente ,result[0]?.FilePermisoOpera)
      // }
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerPermiso({ e, inputs, toast, ref: fileUpload, Token });
      getArchivosPerm(true);
    }


  };

  const subirFileEscritura = async (e) => {
    // const result = await getInfoCliente(idCustomer, Token);
    if (listadoArchivosEscritura?.length >= 1) {
      if (toast) {
        toastShow(
          toast,
          "error",
          "Error",
          "Solo se permite subir 1 archivo. Elimine el Archivo anterior"
        );
      }
    } else {
      // if(result[0]?.FileConstitucion !== null){
      //   await eliminarArchivoEscritura(result[0]?.CodigoCliente ,result[0]?.FileConstitucion)
      // }
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerEscritura({ e, inputs, toast, ref: fileUpload, Token });
      getArchivosEsc(true);
    }

  };

  const subirFileConstancia = async (e) => {
    // const result = await getInfoCliente(idCustomer, Token);

    if (listadoArchivosConstancia?.length >= 1) {
      if (toast) {
        toastShow(
          toast,
          "error",
          "Error",
          "Solo se permite subir 1 archivo. Elimine el Archivo anterior"
        );
      }
    } else {
      // if(result[0]?.FileConstanciaPagosCuenta !== null){
      //   await eliminarArchivoConstancia(result[0]?.CodigoCliente ,result[0]?.FileConstanciaPagosCuenta)
      // }
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerConstancia({ e, inputs, toast, ref: fileUpload, Token });
      getArchivosCons(true);
    }

  };

  const subirFileRegistro = async (e) => {
    // const result = await getInfoCliente(idCustomer, Token);

    if (listadoArchivosRegistro?.length >= 1) {
      if (toast) {
        toastShow(
          toast,
          "error",
          "Error",
          "Solo se permite subir 1 archivo. Elimine el Archivo anterior"
        );
      }
    } else {
      // if(result[0]?.FileRegistroExonerado !== null){
      //   await eliminarArchivoRegistro(result[0]?.CodigoCliente ,result[0]?.FileRegistroExonerado)
      // }
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerRegistro({ e, inputs, toast, ref: fileUpload, Token });
      getArchivosReg(true);
    }

  };

  const subirFileEstados = async (e) => {
    // const result = await getInfoCliente(idCustomer, Token);

    if (listadoArchivosEstados?.length >= 1) {
      if (toast) {
        toastShow(
          toast,
          "error",
          "Error",
          "Solo se permite subir 1 archivo. Elimine el Archivo anterior"
        );
      }
    } else {
      // if(result[0]?.FileEstadosFinancieros !== null){
      //   await eliminarArchivoEstados(result[0]?.CodigoCliente ,result[0]?.FileEstadosFinancieros)
      // }
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerEstados({ e, inputs, toast, ref: fileUpload, Token });
      getArchivosEst(true);
    }

  };

  const subirFileRepresentante = async (e) => {
    // const result = await getInfoCliente(idCustomer, Token);
    if (listadoArchivoRepresentante?.length >= 1) {
      if (toast) {
        toastShow(
          toast,
          "error",
          "Error",
          "Solo se permite subir 1 archivo. Elimine el Archivo anterior"
        );
      }
    } else {
      // if (result[0]?.FileRepresentante !== null) {
      //   await eliminarArchivoRepresentante(
      //     result[0]?.CodigoCliente,
      //     result[0]?.FileRepresentante,
      //     Token
      //   );
      // }
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerRepresentante({ e, inputs, toast, ref: fileUpload, Token });
    }
    getArchivosRepresentante(true);
  };

  const subirFileRefComercial1 = async (e) => {
    // const result = await getInfoCliente(idCustomer, Token);
    if (listadoArchivoRefComercial1?.length >= 1) {
      if (toast) {
        toastShow(
          toast,
          "error",
          "Error",
          "Solo se permite subir 1 archivo. Elimine el Archivo anterior"
        );
      }
    } else {
      // if (result[0]?.FileRefComercial1 !== null) {
      //   await eliminarArchivoRefComercial1(
      //     result[0]?.CodigoCliente,
      //     result[0]?.FileRefComercial1,
      //     Token
      //   );
      // }
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerRefComercial1({ e, inputs, toast, ref: fileUpload, Token });
    }
    getArchivosRefComercial1(true);
  };

  const subirFileRefComercial2 = async (e) => {
    // const result = await getInfoCliente(idCustomer, Token);
    if (listadoArchivoRefComercial2?.length >= 1) {
      if (toast) {
        toastShow(
          toast,
          "error",
          "Error",
          "Solo se permite subir 1 archivo. Elimine el Archivo anterior"
        );
      }
    } else {
      // if (result[0]?.FileRefComercial2 !== null) {
      //   await eliminarArchivoRefComercial2(
      //     result[0]?.CodigoCliente,
      //     result[0]?.FileRefComercial2,
      //     Token
      //   );
      // }
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerRefComercial2({ e, inputs, toast, ref: fileUpload, Token });
    }
    getArchivosRefComercial2(true);
  };

  const subirFileRefBanc1 = async (e) => {
    // const result = await getInfoCliente(idCustomer, Token);
    if (listadoArchivoRefBanc1?.length >= 1) {
      if (toast) {
        toastShow(
          toast,
          "error",
          "Error",
          "Solo se permite subir 1 archivo. Elimine el Archivo anterior"
        );
      }
    } else {
      // if (result[0]?.FileRefBanc1 !== null) {
      //   await eliminarArchivoRefBan1(
      //     result[0]?.CodigoCliente,
      //     result[0]?.FileRefBanc1,
      //     Token
      //   );
      // }
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerRefBanc1({ e, inputs, toast, ref: fileUpload, Token });
    }
    getArchivosRefBanc1();
  };

  const subirFileRefBanc2 = async (e) => {
    // const result = await getInfoCliente(idCustomer, Token);
    if (listadoArchivoRefBanc2?.length >= 1) {
      if (toast) {
        toastShow(
          toast,
          "error",
          "Error",
          "Solo se permite subir 1 archivo. Elimine el Archivo anterior"
        );
      }
    } else {
      // if (result[0]?.FileRefBanc2 !== null) {
      //   await eliminarArchivoRefBan2(
      //     result[0]?.CodigoCliente,
      //     result[0]?.FileRefBanc2,
      //     Token
      //   );
      // }
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerRefBanc2({ e, inputs, toast, ref: fileUpload, Token });
    }
    getArchivosRefBanc2(true);
  };

  const subirFileCerificadoA = async (e) => {
    // const result = await getInfoCliente(idCustomer, Token);
    if (listadoArchivoCertificadoA?.length >= 1) {
      if (toast) {
        toastShow(
          toast,
          "error",
          "Error",
          "Solo se permite subir 1 archivo. Elimine el Archivo anterior"
        );
      }
    } else {
      // if (result[0]?.FileCertificadoAmbiental !== null) {
      //   await eliminarArchivoCertificadoA(
      //     result[0]?.CodigoCliente,
      //     result[0]?.FileCertificadoAmbiental,
      //     Token
      //   );
      // }
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerCertificadoA({ e, inputs, toast, ref: fileUpload, Token });
    }
    getArchivosCertificadoA(true);
  };

  const subirFileCerificadoL = async (e) => {
    // const result = await getInfoCliente(idCustomer, Token);
    if (listadoArchivoCertificadoL?.length >= 1) {
      if (toast) {
        toastShow(
          toast,
          "error",
          "Error",
          "Solo se permite subir 1 archivo. Elimine el Archivo anterior"
        );
      }
    } else {
      // if (result[0]?.FileCertificadoLaboral !== null) {
      //   await eliminarArchivoCertificadoL(
      //     result[0]?.CodigoCliente,
      //     result[0]?.FileCertificadoLaboral,
      //     Token
      //   );
      // }
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerCertificadoL({ e, inputs, toast, ref: fileUpload, Token });
    }
    getArchivosCertificadoL(true);
  };

  const subirFormatoInscripcion = async (e) => {
    // const result = await getInfoCliente(idCustomer, Token);
    setLoading(true)
    if (listadoArchivoFormatoInscripcion?.length >= 1) {
      if (toast) {
        toastShow(
          toast,
          "error",
          "Error",
          "Solo se permite subir 1 archivo. Elimine el Archivo anterior"
        );
      }
    } else {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
        {
          name: "CustomerName",
          type: "text",
          value: referencia.CustomerName,
        },
        {
          name: "Token",
          type: "text",
          value: Token,
        },
      ];
      uploadHandlerFormatoInscripcion({ e, inputs, toast, ref: fileUpload, Token, navigate, lang, setLoading });
    }
    // getArchivosFormatoInscripcion(true);
  };


  // ---------------------------------------------------------------------------------- OBTENER ARCHIVOS --------------------------------------------------------------------------------

  const getArchivos = async (buscar) => {
    const archivo = await getArchivosBIC(values?.CodigoCliente, Token);
    if (buscar) {
      if (archivo?.length === 0) {
        setTimeout(() => {
          getArchivos(true)
        }, 1000);
      }
    }
    setListadoArchivos(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosFact = async (buscar) => {
    const archivo = await getArchivosFactura(values?.CodigoCliente, Token);
    if (buscar) {
      if (archivo?.length === 0) {
        setTimeout(() => {
          getArchivosFact(true)
        }, 1000)
      }
    }
    setListadoArchivosFactura(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosPerm = async (buscar) => {
    const archivo = await getArchivosPermiso(values?.CodigoCliente, Token);
    if (buscar) {
      if (archivo?.length === 0) {
        setTimeout(() => {
          getArchivosPerm(true)
        }, 1000);
      }
    }
    setListadoArchivosPermiso(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosEsc = async (buscar) => {
    const archivo = await getArchivosEscritura(values?.CodigoCliente, Token);
    if (buscar) {
      if (archivo?.length === 0) {
        setTimeout(() => {
          getArchivosEsc(true)
        }, 1000);
      }
    }

    setListadoArchivosEscritura(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosCons = async (buscar) => {
    const archivo = await getArchivosConstancia(values?.CodigoCliente, Token);
    if (buscar) {
      if (archivo?.length === 0) {
        setTimeout(() => {
          getArchivosCons(true)
        }, 1000);
      }
    }
    setListadoArchivosConstancia(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosReg = async (buscar) => {
    const archivo = await getArchivosRegistro(values?.CodigoCliente, Token);
    if (buscar) {
      if (archivo?.length === 0) {
        setTimeout(() => {
          getArchivosReg(true)
        }, 1000);
      }
    }
    setListadoArchivosRegistro(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosEst = async (buscar) => {
    const archivo = await getArchivosEstados(values?.CodigoCliente, Token);
    if (buscar) {
      if (archivo?.length === 0) {
        setTimeout(() => {
          getArchivosEst(true)
        }, 1000);
      }
    }
    setListadoArchivosEstados(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosRepresentante = async (buscar) => {
    const archivo = await getArchivoRepresentante(values?.CodigoCliente, Token);
    if (buscar) {
      if (archivo?.length === 0) {
        setTimeout(() => {
          getArchivosRepresentante(true)
        }, 1000);
      }
    }
    setListadoArchivoRepresentante(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosRefComercial1 = async (buscar) => {
    const archivo = await getArchivoRefComercial1(values?.CodigoCliente, Token);
    if (buscar) {
      if (archivo?.length === 0) {
        setTimeout(() => {
          getArchivosRefComercial1(true)
        }, 1000);
      }
    }
    setListadoArchivoRefComercial1(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosRefComercial2 = async (buscar) => {
    const archivo = await getArchivoRefComercial2(values?.CodigoCliente, Token);
    if (buscar) {
      if (archivo?.length === 0) {
        setTimeout(() => {
          getArchivosRefComercial2(true)
        }, 1000);
      }
    }
    setListadoArchivoRefComercial2(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosRefBanc1 = async (buscar) => {
    const archivo = await getArchivoRefBan1(values?.CodigoCliente, Token);
    if (buscar) {
      if (archivo?.length === 0) {
        setTimeout(() => {
          getArchivosRefBanc1(true)
        }, 1000);
      }
    }
    setListadoArchivoRefBanc1(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosRefBanc2 = async (buscar) => {
    const archivo = await getArchivoRefBan2(values?.CodigoCliente, Token);
    if (buscar) {
      if (archivo?.length === 0) {
        setTimeout(() => {
          getArchivosRefBanc2(true)
        }, 1000);
      }
    }
    setListadoArchivoRefBanc2(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosCertificadoA = async (buscar) => {
    const archivo = await getArchivoCertificadoA(values?.CodigoCliente, Token);
    if (buscar) {
      if (archivo?.length === 0) {
        setTimeout(() => {
          getArchivosCertificadoA(true)
        }, 1000);
      }
    }
    setListadoArchivoCertificadoA(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosCertificadoL = async (buscar) => {
    const archivo = await getArchivoCertificadoL(values?.CodigoCliente, Token);
    if (buscar) {
      if (archivo?.length === 0) {
        setTimeout(() => {
          getArchivosCertificadoL(true)
        }, 1000);
      }
    }
    setListadoArchivoCertificadoL(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosFormatoInscripcion = async (buscar) => {
    const archivo = await getArchivoFormatoInscripcion(values?.CodigoCliente, Token);
    if (buscar) {
      if (archivo?.length === 0) {
        setTimeout(() => {
          getArchivosFormatoInscripcion(true)
        }, 1000);
      }
    }
    setListadoArchivoFormatoInscripcion(Array.isArray(archivo) ? archivo : []);

    const Datos = {
      FileFormatoInscripcion: archivo[0],
      IdCustomer: values?.IdCustomer
    }
    if (archivo?.length > 0) {
      const guardarNombre = await guardarNombreFormato(Datos, Token)
    }
    setLoading(false);
    return archivo;
  };

  //---------------------------------------------------------------------------------- DESCARGAR ARCHIVOS ----------------------------------------------------------------------------------

  const getArchivo = async (nombre) => {
    const a = await descargarArchivoBIC(values?.CodigoCliente, nombre, Token);
    downloadFile(a, nombre);
  };

  const getArchivoFactura = async (nombre) => {
    const a = await descargarArchivoFactura(values?.CodigoCliente, nombre, Token);
    downloadFile(a, nombre);
  };

  const getArchivoPermiso = async (nombre) => {
    const a = await descargarArchivoPermiso(values?.CodigoCliente, nombre, Token);
    downloadFile(a, nombre);
  };

  const getArchivoEscritura = async (nombre) => {
    const a = await descargarArchivoEscritura(values?.CodigoCliente, nombre, Token);
    downloadFile(a, nombre);
  };

  const getArchivoConstancia = async (nombre) => {
    const a = await descargarArchivoConstancia(values?.CodigoCliente, nombre, Token);
    downloadFile(a, nombre);
  };

  const getArchivoRegistro = async (nombre) => {
    const a = await descargarArchivoRegistro(values?.CodigoCliente, nombre, Token);
    downloadFile(a, nombre);
  };

  const getArchivoEstados = async (nombre) => {
    const a = await descargarArchivoEstados(values?.CodigoCliente, nombre, Token);
    downloadFile(a, nombre);
  };

  const getArchivoRep = async (nombre) => {
    const a = await descargarArchivoRepresentante(values?.CodigoCliente, nombre, Token);
    downloadFile(a, nombre);
  };

  const descargarRefComercial1 = async (nombre) => {
    const a = await descargarArchivoRefComercial1(values?.CodigoCliente, nombre, Token);
    downloadFile(a, nombre);
  };

  const descargarRefComercial2 = async (nombre) => {
    const a = await descargarArchivoRefComercial2(values?.CodigoCliente, nombre, Token);
    downloadFile(a, nombre);
  };

  const descargarRefBanc1 = async (nombre) => {
    const a = await descargarArchivoRefBan1(values?.CodigoCliente, nombre, Token);
    downloadFile(a, nombre);
  };

  const descargarRefBanc2 = async (nombre) => {
    const a = await descargarArchivoRefBan2(values?.CodigoCliente, nombre, Token);
    downloadFile(a, nombre);
  };

  const descargarFormato = async (nombre) => {
    const a = await descargarArchivoFormatoInscripcion(values?.CodigoCliente, nombre, Token);
    downloadFile(a, nombre);
  };

  const descargarCertificadoL = async (nombre) => {
    const a = await descargarArchivoCertificadoL(values?.CodigoCliente, nombre, Token);
    downloadFile(a, nombre);
  };

  const descargarCertificadoA = async (nombre) => {
    const a = await descargarArchivoCertificadoA(values?.CodigoCliente, nombre, Token);
    downloadFile(a, nombre);
  };

  //---------------------------------------------------------------------------------- ELIMINAR ARCHIVOS ----------------------------------------------------------------------------------


  const eliminar = async (nombre) => {
    const a = await eliminarArchivoBIC(values?.CodigoCliente, nombre, Token);
    toastShow(
      toast,
      "success",
      "Eliminado",
      "Archivo eliminado correctamente."
    );
    setListadoArchivos(listadoArchivos.filter((archivo) => archivo !== nombre));
  };

  const eliminarFactura = async (nombre) => {
    const a = await eliminarArchivoFactura(values?.CodigoCliente, nombre, Token);
    toastShow(
      toast,
      "success",
      "Eliminado",
      "Archivo eliminado correctamente."
    );
    setListadoArchivosFactura(listadoArchivosFactura.filter((archivo) => archivo !== nombre));
  };

  const eliminarPermiso = async (nombre) => {
    const a = await eliminarArchivoPermiso(values?.CodigoCliente, nombre, Token);
    toastShow(
      toast,
      "success",
      "Eliminado",
      "Archivo eliminado correctamente."
    );
    setListadoArchivosPermiso(listadoArchivosPermiso.filter((archivo) => archivo !== nombre));
  };

  const eliminarEscritura = async (nombre) => {
    const a = await eliminarArchivoEscritura(values?.CodigoCliente, nombre, Token);
    toastShow(
      toast,
      "success",
      "Eliminado",
      "Archivo eliminado correctamente."
    );
    setListadoArchivosEscritura(listadoArchivosEscritura.filter((archivo) => archivo !== nombre));
  };

  const eliminarConstancia = async (nombre) => {
    const a = await eliminarArchivoConstancia(values?.CodigoCliente, nombre, Token);
    toastShow(
      toast,
      "success",
      "Eliminado",
      "Archivo eliminado correctamente."
    );
    setListadoArchivosConstancia(listadoArchivosConstancia.filter((archivo) => archivo !== nombre));
  };

  const eliminarConstanciaSinToast = async (nombre) => {
    const a = await eliminarArchivoConstancia(values?.CodigoCliente, nombre, Token);
    setListadoArchivosConstancia(listadoArchivosConstancia.filter((archivo) => archivo !== nombre));
  };

  const eliminarRegistro = async (nombre) => {
    const a = await eliminarArchivoRegistro(values?.CodigoCliente, nombre, Token);
    // toastShow(
    //   toast,
    //   "success",
    //   "Cancelado",
    //   "Registro eliminado correctamente."
    // );
    setListadoArchivosRegistro(listadoArchivosRegistro.filter((archivo) => archivo !== nombre));
  };

  const eliminarRep = async (nombre) => {
    const a = await eliminarArchivoRepresentante(values?.CodigoCliente, nombre, Token);
    toastShow(
      toast,
      "success",
      "Eliminado",
      "Archivo eliminado correctamente."
    );
    setListadoArchivoRepresentante(listadoArchivoRepresentante.filter((archivo) => archivo !== nombre));
  };

  const eliminarRefComercial1 = async (nombre) => {
    const a = await eliminarArchivoRefComercial1(values?.CodigoCliente, nombre, Token);
    toastShow(
      toast,
      "success",
      "Eliminado",
      "Archivo eliminado correctamente."
    );
    setListadoArchivoRefComercial1(listadoArchivoRefComercial1.filter((archivo) => archivo !== nombre));
  };

  const eliminarRefComercial2 = async (nombre) => {
    const a = await eliminarArchivoRefComercial2(values?.CodigoCliente, nombre, Token);
    toastShow(
      toast,
      "success",
      "Eliminado",
      "Archivo eliminado correctamente."
    );
    setListadoArchivoRefComercial2(listadoArchivoRefComercial2.filter((archivo) => archivo !== nombre));
  };

  const eliminarRefBanc1 = async (nombre) => {
    const a = await eliminarArchivoRefBan1(values?.CodigoCliente, nombre, Token);
    toastShow(
      toast,
      "success",
      "Eliminado",
      "Archivo eliminado correctamente."
    );
    setListadoArchivoRefBanc1(listadoArchivoRefBanc1.filter((archivo) => archivo !== nombre));
  };

  const eliminarRefBanc2 = async (nombre) => {
    const a = await eliminarArchivoRefBan2(values?.CodigoCliente, nombre, Token);
    toastShow(
      toast,
      "success",
      "Eliminado",
      "Archivo eliminado correctamente."
    );
    setListadoArchivoRefBanc2(listadoArchivoRefBanc2.filter((archivo) => archivo !== nombre));
  };

  const eliminarCertificadoA = async (nombre) => {
    const a = await eliminarArchivoCertificadoA(values?.CodigoCliente, nombre, Token);
    toastShow(
      toast,
      "success",
      "Eliminado",
      "Archivo eliminado correctamente."
    );
    setListadoArchivoCertificadoA(listadoArchivoCertificadoA.filter((archivo) => archivo !== nombre));
  };

  const eliminarCertificadoL = async (nombre) => {
    const a = await eliminarArchivoCertificadoL(values?.CodigoCliente, nombre, Token);
    toastShow(
      toast,
      "success",
      "Eliminado",
      "Archivo eliminado correctamente."
    );
    setListadoArchivoCertificadoL(listadoArchivoCertificadoL.filter((archivo) => archivo !== nombre));
  };

  const eliminarFormatoInscripcion = async (nombre) => {
    const a = await eliminarArchivoFormatoInscripcion(values?.CodigoCliente, nombre, Token);
    toastShow(
      toast,
      "success",
      "Eliminado",
      "Archivo eliminado correctamente."
    );
    setListadoArchivoFormatoInscripcion(listadoArchivoFormatoInscripcion.filter((archivo) => archivo !== nombre));
    const Datos = {
      IdCustomer: values?.IdCustomer
    }
    const eliminarNombre = await eliminarNombreFormato(Datos, Token)
  };

  const eliminarRegistroSinToast = async (nombre) => {
    const a = await eliminarArchivoRegistro(values?.CodigoCliente, nombre, Token);
    setListadoArchivosRegistro(listadoArchivosRegistro?.filter((archivo) => archivo !== nombre));
  };

  const eliminarEstados = async (nombre) => {
    const a = await eliminarArchivoEstados(values?.CodigoCliente, nombre, Token);
    toastShow(
      toast,
      "success",
      "Eliminado",
      "Archivo eliminado correctamente."
    );
    setListadoArchivosEstados(listadoArchivosEstados.filter((archivo) => archivo !== nombre));
  };

  // ----------------------------------------------------------------------------------------------------------------------------------------------------------------

  const agregarAccionista = async () => {
    let error = false;

    if (!values?.NombreAccionista) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrNombre', idioma)}`);
      error = true;
      return;
    }
    if (!values?.IdentificacionAccionista) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrId', idioma)}`);
      error = true;
      return;
    }
    if (!values?.Nacionalidad) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrNacionalidad', idioma)}`);
      error = true;
      return;
    }
    // if (!values?.DireccionAccionista) {
    //   toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrAddress', idioma)}`);
    //   error = true;
    //   return;
    // }
    if (!values?.PorcentajeParticipacion) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrParticipacion', idioma)}`);
      error = true;
      return;
    }
    // if (!values?.EmailAccionista) {
    //   toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrEmail', idioma)}`);
    //   error = true;
    //   return;
    // }

    if (!error) {
      let newRowData = [...listadoAccionistas];

      if (values.Id) {
        newRowData = newRowData.map(accionista =>
          accionista.Id === values.Id ? { ...accionista, ...values, Nacionalidad: values?.Nacionalidad.Name || values?.Nacionalidad } : accionista
        );
      } else {

        let index = -1 * parseInt((+new Date().getTime() + "").substring(9, 14));
        const newData = {
          Id: index,
          NombreAccionista: values?.NombreAccionista,
          IdentificacionAccionista: values?.IdentificacionAccionista,
          IdCountry: values?.Nacionalidad?.Id,
          Nacionalidad: values?.Nacionalidad?.Name || values?.Nacionalidad,
          DireccionAccionista: values?.DireccionAccionista,
          PorcentajeParticipacion: values?.PorcentajeParticipacion,
          EmailAccionista: values?.EmailAccionista
        };


        newRowData.push(newData);
      }

      setListadoAccionistas(newRowData);
      resetAccionistas();
    }
  };

  const agregarDirectores = async () => {
    let error = false;

    if (!values?.NombreDirector) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrNombre', idioma)}`);
      error = true;
      return;
    }
    if (!values?.IdentificacionDirector) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrId', idioma)}`);
      error = true;
      return;
    }
    if (!values?.NacionalidadDirector) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrNacionalidad', idioma)}`);
      error = true;
      return;
    }
    // if (!values?.DireccionAccionista) {
    //   toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrAddress', idioma)}`);
    //   error = true;
    //   return;
    // }
    if (!values?.Posicion) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrPosicion', idioma)}`);
      error = true;
      return;
    }
    // if (!values?.EmailDirector) {
    //   toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrEmail', idioma)}`);
    //   error = true;
    //   return;
    // }

    if (!error) {
      let newRowData = [...listadoDirectores];

      if (values.Id) {
        newRowData = newRowData.map(director =>
          director.Id === values.Id ? { ...director, ...values, Nacionalidad: values?.NacionalidadDirector.Name || values?.NacionalidadDirector } : director
        );
      } else {

        let index = -1 * parseInt((+new Date().getTime() + "").substring(9, 14));
        const newData = {
          Id: index,
          NombreDirector: values?.NombreDirector,
          IdentificacionDirector: values?.IdentificacionDirector,
          IdCountry: values?.NacionalidadDirector?.Id,
          NacionalidadDirector: values?.NacionalidadDirector?.Name || values?.NacionalidadDirector,
          Posicion: values?.Posicion,
          EmailDirector: values?.EmailDirector
        };

        newRowData.push(newData);
      }

      setListadoDirectores(newRowData);
      resetDirectores();
    }
  };

  const resetAccionistas = () => {
    setValues({
      ...values,
      Id: null,
      NombreAccionista: '',
      IdentificacionAccionista: '',
      DireccionAccionista: '',
      PorcentajeParticipacion: '',
      Nacionalidad: '',
      EmailAccionista: '',
    });
  };

  const resetDirectores = () => {
    setValues({
      ...values,
      Id: null,
      NombreDirector: '',
      IdentificacionDirector: '',
      Posicion: '',
      NacionalidadDirector: '',
      EmailDirector: ''
    });
  };

  const editarAccionista = (id) => {
    const accionistaAEditar = listadoAccionistas.find((accionista) => accionista.Id === id);

    if (accionistaAEditar) {
      setValues({
        ...values,
        Id: accionistaAEditar.Id,
        NombreAccionista: accionistaAEditar.NombreAccionista,
        IdentificacionAccionista: accionistaAEditar.IdentificacionAccionista,
        Nacionalidad: accionistaAEditar?.Nacionalidad,
        DireccionAccionista: accionistaAEditar.DireccionAccionista,
        PorcentajeParticipacion: accionistaAEditar.PorcentajeParticipacion,
        EmailAccionista: accionistaAEditar?.EmailAccionista
      });
    }
  };

  const editarDirector = (id) => {
    const directorAEditar = listadoDirectores.find((director) => director.Id === id);
    if (directorAEditar) {
      setValues({
        ...values,
        Id: directorAEditar.Id,
        NombreDirector: directorAEditar.NombreDirector,
        IdentificacionDirector: directorAEditar.IdentificacionDirector,
        NacionalidadDirector: directorAEditar?.NacionalidadDirector,
        Posicion: directorAEditar.Posicion,
        EmailDirector: directorAEditar?.EmailDirector
      });
    }
  };

  const eliminarAccionista = (accionistaId) => {
    const nuevosAccionistas = listadoAccionistas.filter(accionista => accionista.Id !== accionistaId);
    setListadoAccionistas(nuevosAccionistas);
  };

  const eliminarDirector = (accionistaId) => {
    const nuevosAccionistas = listadoDirectores.filter(director => director.Id !== accionistaId);
    setListadoDirectores(nuevosAccionistas);
  };


  useEffect(() => {
    const decoded = decodeToken(Token);
    if (!decoded || decoded.exp < Date.now() / 1000) {
      return;
    }
    getInfo();
    setIdioma(lang);
    document.title = process.env.REACT_APP_CompanyNameShort + " • " + setLabel("Titulo");

    const html = document.querySelector("html");
    html.setAttribute("lang", lang);

    if (decoded) {
      setTokenInfo(decoded);
      const { IdCustomer } = decoded;
      if (IdCustomer) {
        setIdCustomer(IdCustomer);
        getCompanyInfo(IdCustomer);
      }
    }
  }, []);

  useEffect(() => {

    verificarCampos()

  }, [values, listadoAccionistas, listadoArchivoCertificadoA, listadoArchivoCertificadoL, listadoArchivosPermiso, listadoArchivoRefBanc1, listadoArchivoRefBanc2,
    listadoArchivoRefComercial1, listadoArchivoRefComercial2, listadoArchivoRepresentante, listadoArchivos, listadoArchivosConstancia, listadoArchivosEscritura,
    listadoArchivosEstados, listadoArchivosFactura, listadoArchivosRegistro
  ]);

  useEffect(() => {
    setArchivoSelected(0)
  }, [values?.Country]);

  useEffect(() => {
    let Id = values?.Nombre?.IdTipoPago ? values?.Nombre?.IdTipoPago : values?.IdTipoPagoCliente
    if (Id === 2) {
      setHabilitarCredito(true)
    } else {
      setHabilitarCredito(false)
    }
  }, [values?.Nombre?.IdTipoPago || values?.IdTipoPagoCliente]);


  const mensajeFaltantes = (
    <div>
      <p>{setLabel('msgNoEditableIncompleta')}</p>
      <strong>{setLabel('InformacionFaltante')}:</strong>
      <div>
        <ul>
          {listaFaltantes?.map((item, index) => (
            item !== '' ? <li key={index} className="mx-4">
              <span style={{ color: 'red' }}>-</span> {item}
            </li> : null
          ))}
        </ul>
      </div>
    </div>
  );

  const DescargarManualDeInscripcion = async () => {
    const a = await DescargarManual(idioma, Token);
    let nombre = idioma === 'es' ? 'Manual de Inscripción.pdf' : 'Registration Manual.pdf'
    downloadFile(a, nombre);
  }

  const footerDialog = (
    <React.Fragment>
      <Button
        label={setLabel('no')}
        icon="pi pi-times"
        onClick={() => {
          setShowDialogIncompleto(false)
        }}
      />
      <Button
        label={setLabel('guardarBorrador')}
        icon="pi pi-check"
        className="p-button-success"
        onClick={() => guardarInscripcion(true)}
      />
    </React.Fragment>
  );


  if (tokenInfo) {
    return (
      <div id='inscripcion'>
        <Loader loading={loading} querySelector='#inscripcion' />
        <Toast position="bottom-right" ref={toast} />
        <ConfirmDialog
          visible={showDialog}
          onHide={() => setShowDialog(false)}
          header={setLabel('msgConfirmacion')}
          message={setLabel('msgNoEditable')}
          icon="pi pi-exclamation-triangle"
          rejectClassName="p-button-secondary"
          acceptClassName="p-button-success"
          accept={() => guardarInscripcion(false)}
          reject={e => setShowDialog(false)}
          acceptLabel={setLabel('si')}
          rejectLabel={setLabel('no')}
        />
        <ConfirmDialog />

        {/* <ConfirmDialog
          visible={showDialogIncompleto}
          onHide={() => setShowDialogIncompleto(false)}
          header={setLabel('msgConfirmacionIncompleta')}
          message={mensajeFaltantes}
          icon="pi pi-exclamation-triangle"
          rejectClassName="p-button-secondary"
          acceptClassName="p-button-success"
          accept={() => guardarInscripcion(true)}
          reject={e => setShowDialogIncompleto(false)}
          acceptLabel={setLabel('GuardarBorrador')}
          rejectLabel={setLabel('no')}
        /> */}


        {showDialogIncompleto && (
          <Dialog
            visible={showDialogIncompleto}
            onHide={() => setShowDialogIncompleto(false)}
            header={setLabel('msgConfirmacionIncompleta')}
            footer={footerDialog}
          >
            {mensajeFaltantes}
          </Dialog>
        )}



        <div className="ClienteInfoContainer">
          <div className="col-12">
            <div className="header">
              <div className="columna">
                <div className={config.theme === "Dark" ? "texto-blanco" : ""}>
                  <h1>{setLabel("Titulo")}</h1>
                  <div className="gap-1">
                    <h3>
                      {setLabel("codigoCliente")}: <span className="font-weight-bold text-decoration-underline">{cliente[0]?.CodigoCliente}</span>
                    </h3>
                    {userAuth?.idUser ?
                      <div className='d-flex gap'>
                        {/* <div style={{ width: 150, alignContent: 'center' }}> */}
                          <Tag value={values?.EstadoRevisado} className={`status-${values?.IdEstadoRevisado}`} style={{ height: 40 }} />
                        {/* </div> */}
                        <div className='d-flex flex-column'>
                          <span> {values?.UsuarioVentas ? (`Revisado Ventas: ` + values?.UsuarioVentas + ' - ' + values.SalesReviewedDate) : ''}</span>
                          <span> {values?.UsuarioFinanzas ? (`Revisado Finanzas: ` + values?.UsuarioFinanzas + ' - ' + values.FinanceReviewedDate) : ''}</span>
                          <span> {values?.FechaLlenoFormato ? (`Fecha Lleno Formato: ` + getDateTimeString(new Date(values?.FormatCompletedDate))) : ''}</span>
                        </div>
                      </div>
                      : null
                    }
                  </div>
                </div>
                {config.theme === "Light" ? (
                  <img
                    src={`${process.env.REACT_APP_Logo_Primario_H}`}
                    alt="Imagen"
                    className="logo"
                  />
                ) : (
                  <img
                    src={`${process.env.REACT_APP_Logo_Primario_H}`}
                    alt="Imagen"
                    className="logo"
                  />
                )}
              </div>

              <div className="switchIdioma">
                <Button
                  label={setLabel("Descargar Manual")}
                  className="mx-4"
                  icon="pi pi-download"
                  onClick={(e) => { DescargarManualDeInscripcion() }}
                />

                <SelectButton
                  value={idioma}
                  options={[
                    { label: "English", value: "en" },
                    { label: "Español", value: "es" },
                  ]}
                  onChange={(e) => setIdioma(e.value ? e.value : "es")}
                />
                <div className="mx-3">
                  <Button
                    text={config.theme === "Light"}
                    icon="pi pi-sun"
                    tooltip="Light"
                    onClick={(e) => {
                      changeTheme("Light");
                    }}
                    severity={config.theme === "Light" ? "primary" : "secondary"}
                  />
                  <Button
                    text={config.theme === "Dark"}
                    icon="pi pi-moon"
                    tooltip="Dark"
                    onClick={(e) => {
                      changeTheme("Dark");
                    }}
                    severity={config.theme === "Dark" ? "primary" : "secondary"}
                  />
                </div>
              </div>
            </div>

            <div>
              {/* INFORMACION DEl CLIENTE */}
              <Card
                // titulo={setLabel("informacionClienteTitle")}
                titulo={
                  <h2 style={{ fontSize: "18px", fontWeight: "bold" }}>
                    {setLabel("informacionClienteTitle")}
                  </h2>
                }
                contenido={
                  <div>
                    <div className="inputsProveedorContainer">
                      {/* Nombre Comercial (Si es distinto al nombre de la casa matriz) */}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.CustomerName}
                            onChange={(e) => handleInputChange(e, "CustomerName")}
                            className={classNames({
                              "p-invalid": showMessages?.CustomerName,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("NombreCliente")}</label>
                        </div>
                      </div>

                      {/* PAIS */}
                      <div>
                        <AutoCompleteDropdown
                          name={"Country"}
                          value={values.Country}
                          label={setLabel("Pais")}
                          items={Countries}
                          field={"Name"}
                          handleInputChange={handleInputChange}
                          className={classNames({
                            "p-invalid": showMessages?.Country,
                          })}
                          enable={editable}
                        />
                      </div>

                      {/* ESTADO*/}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.State}
                            onChange={(e) => handleInputChange(e, "State")}
                            className={classNames({
                              "p-invalid": showMessages?.State,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("Estado")}</label>
                        </div>
                      </div>

                      {/* CIUDAD*/}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.City}
                            onChange={(e) => handleInputChange(e, "City")}
                            className={classNames({
                              "p-invalid": showMessages?.City,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("Ciudad")}</label>
                        </div>
                      </div>

                      {/* Direccion Comercial */}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.Address}
                            onChange={(e) => handleInputChange(e, "Address")}
                            className={classNames({
                              "p-invalid": showMessages?.Address,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("Direccion")}</label>
                        </div>
                      </div>

                      {values?.Country?.Id === IdHonduras ? (
                        <div className="field">
                          <span className="p-float-label p-input-icon-right">
                            <InputMask id="righticon"
                              mask="9999-9999-999999"
                              value={values?.RTN}
                              onChange={handleInputChange}
                              name={'RTN'}
                              style={{ width: '100%' }}
                              className={classNames({
                                "p-invalid": showMessages?.RTN,
                              })}
                              disabled={!editable}
                            />
                            <label htmlFor="righticon">RTN</label>
                          </span>
                        </div>
                      ) : (
                        <div className="input-contenedor">
                          <div className="p-float-label">
                            <InputText
                              value={values.RTN}
                              onChange={(e) => handleInputChange(e, "RTN")}
                              className={classNames({
                                "p-invalid": showMessages?.RTN,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("NumIdentificacionTributaria")}</label>
                          </div>
                        </div>
                      )}

                      {/* Número de teléfono principal */}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.Tel}
                            onChange={(e) => handleInputChange(e, "Tel")}
                            className={classNames({
                              "p-invalid": showMessages?.Tel,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("TelefonoRef")}</label>
                        </div>
                      </div>

                      {/* Correo electrónico */}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.Email}
                            onChange={(e) => handleInputChange(e, "Email")}
                            className={classNames({
                              "p-invalid": showMessages?.Email,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("Email")}</label>
                        </div>
                      </div>

                      {/* Principal actividad económica */}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.PrincipalActividadEconomica}
                            onChange={(e) =>
                              handleInputChange(e, "PrincipalActividadEconomica")
                            }
                            className={classNames({
                              "p-invalid":
                                showMessages?.PrincipalActividadEconomica,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("actividadEconomica")}</label>
                        </div>
                      </div>

                      {/* Tipo de Factura */}
                      <div>
                        <AutoCompleteDropdown
                          name={"TipoPagos"}
                          value={values.TipoPagos}
                          label={setLabel("TipoFacturacion")}
                          items={tipoPagos}
                          field={idioma === 'es' ? "TipoPago" : "TipoPagoEn"}
                          handleInputChange={handleInputChange}
                          className={classNames({
                            "p-invalid": showMessages?.TipoPagos,
                          })}
                          enable={editable}
                        />
                      </div>

                      {/* Nombre de la casa matriz */}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.CasaMatriz}
                            onChange={(e) => handleInputChange(e, "CasaMatriz")}
                            className={classNames({
                              "p-invalid": showMessages?.CasaMatriz,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("nombreCasaMatriz")}</label>
                        </div>
                        <small>{setLabel("distCasaMatriz")}</small>
                      </div>

                      {/* Dirección de la casa matriz */}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.DireccionCasaMatriz}
                            onChange={(e) =>
                              handleInputChange(e, "DireccionCasaMatriz")
                            }
                            className={classNames({
                              "p-invalid": showMessages?.DireccionCasaMatriz,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("direccionCasaMatriz")}</label>
                        </div>
                        <small>{setLabel("distDireccionComercial")}</small>
                      </div>


                      {/* Tipo de PAGO */}
                      <div className="mt-4 mx-2 d-flex align-items-center">
                        <h4 htmlFor="solicitaCredito" style={{ color: "var(--text-color)" }} className="mx-2 mt-2">{setLabel("SolicitaCredito")}</h4>
                        <Checkbox
                          inputId="solicitaCredito"
                          checked={habilitarCredito}
                          onChange={handleCheckboxChange}
                          disabled={!editable}
                        />
                      </div>

                    </div>
                    {/* MENSAJES DE ERROR */}
                    {/* {showMessages.General && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>} */}
                  </div>
                }
              />

              {/* INFORMACION DE CONTACTO REPRESENTANTE LEGAL */}
              <Card
                // titulo={setLabel("informacionContactoRepresentanteLegal")}
                titulo={
                  <h2 style={{ fontSize: "18px", fontWeight: "bold" }}>
                    {setLabel("informacionContactoRepresentanteLegal")}
                  </h2>
                }
                contenido={
                  <div className={config.theme === "Dark" ? "texto-blanco" : ""}>
                    <div className="inputsProveedorContainer">
                      {/* Nombre del representante legal */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.NombreRepresentanteLegal}
                            onChange={(e) =>
                              handleInputChange(e, "NombreRepresentanteLegal")
                            }
                            className={classNames({
                              "p-invalid": showMessages?.NombreRepresentanteLegal,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("Nombre")}</label>
                        </div>
                      </div>

                      {/* Telefono del representante legal */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.TelefonoRepresentante}
                            onChange={(e) =>
                              handleInputChange(e, "TelefonoRepresentante")
                            }
                            className={classNames({
                              "p-invalid": showMessages?.TelefonoRepresentante,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("TelefonoRef")}</label>
                        </div>
                      </div>

                      {/* Correo electrónico */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.CorreoRepresentante}
                            onChange={(e) =>
                              handleInputChange(e, "CorreoRepresentante")
                            }
                            className={classNames({
                              "p-invalid": showMessages?.CorreoRepresentante,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("Email")}</label>
                        </div>
                      </div>

                      {/* Identificacion */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.IdentificacionRepresentante}
                            onChange={(e) =>
                              handleInputChange(e, "IdentificacionRepresentante")
                            }
                            className={classNames({
                              "p-invalid": showMessages?.IdentificacionRepresentante,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("NumIdentificacionTributaria")}</label>
                        </div>
                      </div>

                    </div>
                    <div>
                      <label style={{ minHeight: 'auto', marginLeft: '12px' }}>
                        {setLabel("IdentificacionReg")}:
                      </label>
                      <div style={{ minHeight: 'auto', marginLeft: '12px' }}>
                        <FileUpload
                          ref={fileUpload}
                          name="demo"
                          url="./upload"
                          customUpload
                          uploadHandler={subirFileRepresentante}
                          required
                          auto
                          maxFileSize={5242880} //EQUIVALENTE A 5 MB
                          disabled={!editable}
                        />
                        {showMessages?.FileRepresentante && (
                          <small className="p-error">
                            Por favor, agregue un archivo.
                          </small>
                        )}
                        <div className="mt-3 mb-3">
                          <div>
                            {listadoArchivoRepresentante?.map((a, i) => (
                              <div
                                className="d-flex gap p-2 border mt-2"
                                style={{ alignItems: "center" }}
                                key={i}
                              >
                                <div className="col-9">{a}</div>
                                <Button
                                  icon="pi pi-download"
                                  onClick={() => getArchivoRep(a)}
                                  disabled={!editable}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  severity="danger"
                                  onClick={() => eliminarRep(a)}
                                  disabled={!editable}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>



                    {/* MENSAJES DE ERROR */}
                    {showMessages.RepresentanteLegal && (
                      <div className="p-error">
                        {setLabel("completarCamposObligatorios")}
                      </div>
                    )}
                  </div>
                }
              />

              {/* SOCIOS DE EMPRESA */}
              {habilitarCredito && (
                <Card
                  titulo={
                    <h2 style={{ fontSize: "18px", fontWeight: "bold" }}>
                      {setLabel("Socios")}
                    </h2>
                  }
                  contenido={
                    <div className={config.theme === "Dark" ? "texto-blanco" : ""}>
                      {/* Inputs para agregar o editar un socio */}
                      <div className="inputsProveedorContainer">
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.NombreAccionista}
                              onChange={(e) => handleInputChange(e, "NombreAccionista")}
                              className={classNames({
                                "p-invalid": showMessages?.NombreAccionista,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("Nombre")}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.IdentificacionAccionista}
                              onChange={(e) =>
                                handleInputChange(e, "IdentificacionAccionista")
                              }
                              className={classNames({
                                "p-invalid": showMessages?.IdentificacionAccionista,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("Identificacion")}</label>
                          </div>
                        </div>

                        <div>
                          <AutoCompleteDropdown
                            name={"Nacionalidad"}
                            value={values.Nacionalidad}
                            label={setLabel("Pais")}
                            items={Countries}
                            field={"Name"}
                            handleInputChange={handleInputChange}
                            className={classNames({
                              "p-invalid": showMessages?.Nacionalidad,
                            })}
                            enable={editable}
                          />
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputNumber
                              value={values?.PorcentajeParticipacion}
                              onChange={(e) =>
                                handleInputChange(e, "PorcentajeParticipacion")
                              }
                              suffix=" %"
                              disabled={!editable}
                              style={{ width: "100%" }}
                            />
                            <label>{setLabel("Porcentaje")}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.EmailAccionista}
                              onChange={(e) => handleInputChange(e, "EmailAccionista")}
                              className={classNames({
                                "p-invalid": showMessages?.EmailAccionista,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("Email")}</label>
                          </div>
                        </div>

                        <div className="mt-3">
                          <Button
                            icon="pi pi-plus"
                            type="button"
                            disabled={!editable}
                            tooltip={setLabel("Agregar Accionista")}
                            tooltipOptions={{
                              className: "purple-tooltip",
                              position: "top",
                            }}
                            onClick={agregarAccionista}
                          />
                        </div>
                      </div>

                      {/* Mensajes de error */}
                      {showMessages.ErrorAccionistas && (
                        <div className="p-error">
                          {setLabel("completarCamposObligatorios")}
                        </div>
                      )}

                      {/* Tabla de socios */}
                      <div
                        style={{ width: '50%' }}
                        className="mx-3 mb-3"
                      >
                        <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: "250px" }}>
                          {listadoAccionistas?.length > 0 && (
                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                              <thead style={{ backgroundColor: "#4CAF50", color: "black" }}>
                                <tr>
                                  <th style={{ padding: "8px !important", border: "1px solid #ddd", width: "30%" }}>
                                    <div className="p-2">
                                      {setLabel("Nombre")}
                                    </div>
                                  </th>
                                  <th style={{ padding: "8px", border: "1px solid #ddd", width: "20%" }}>
                                    <div className="p-2">
                                      {setLabel("Identificacion")}
                                    </div>
                                  </th>
                                  <th style={{ padding: "8px", border: "1px solid #ddd", width: "15%" }}>
                                    <div className="p-2">
                                      {setLabel("Porcentaje")}
                                    </div>
                                  </th>
                                  <th style={{ padding: "8px", border: "1px solid #ddd", width: "20%" }}>
                                    <div className="p-2">
                                      {setLabel("Nacionalidad")}
                                    </div>
                                  </th>
                                  <th style={{ padding: "8px", border: "1px solid #ddd", width: "15%" }}>
                                    {/* {setLabel("Acciones")} */}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {listadoAccionistas.map((accionista, index) => (
                                  <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                                    <td style={{ padding: "8px", border: "1px solid #ddd", width: "25%" }}>
                                      {accionista.NombreAccionista}
                                    </td>
                                    <td style={{ padding: "8px", border: "1px solid #ddd", width: "25%" }}>
                                      {accionista.IdentificacionAccionista}
                                    </td>
                                    <td style={{ padding: "8px", border: "1px solid #ddd", width: "15%", textAlign: "center" }}>
                                      {accionista.PorcentajeParticipacion}%
                                    </td>
                                    <td style={{ padding: "8px", border: "1px solid #ddd", width: "20%" }}>
                                      {accionista.Nacionalidad}
                                    </td>
                                    <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center", width: "15%" }}>
                                      <button
                                        onClick={() => editarAccionista(accionista.Id)}
                                        disabled={!editable}
                                        style={{ backgroundColor: "transparent", border: "none", padding: "0", cursor: "pointer", marginRight: "10px" }} // Agregar margen derecho
                                      >
                                        <i className="pi pi-pencil"></i>
                                      </button>

                                      <button
                                        onClick={() => eliminarAccionista(accionista.Id)}
                                        disabled={!editable}
                                        style={{ backgroundColor: "transparent", border: "none", padding: "0", cursor: "pointer" }}
                                      >
                                        <i className="pi pi-trash"></i>
                                      </button>
                                    </td>

                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </div>

                    </div>
                  }
                />
              )}


              {/* DIRECTORES DE EMPRESA */}
              {habilitarCredito && (
                <Card
                  // titulo={setLabel("Directores")}
                  titulo={
                    <h2 style={{ fontSize: "18px", fontWeight: "bold" }}>
                      {setLabel("Directores")}
                    </h2>
                  }
                  contenido={
                    <div className={config.theme === "Dark" ? "texto-blanco" : ""}>
                      {/* Inputs */}
                      <div className="inputsProveedorContainer">
                        {/* Nombre Director */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.NombreDirector}
                              onChange={(e) =>
                                handleInputChange(e, "NombreDirector")
                              }
                              className={classNames({
                                "p-invalid": showMessages?.NombreDirector,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("Nombre")}</label>
                          </div>
                        </div>

                        {/* Identificacion Director*/}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.IdentificacionDirector}
                              onChange={(e) =>
                                handleInputChange(e, "IdentificacionDirector")
                              }
                              className={classNames({
                                "p-invalid": showMessages?.IdentificacionDirector,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("Identificacion")}</label>
                          </div>
                        </div>

                        {/* PAIS */}
                        <div>
                          <AutoCompleteDropdown
                            name={"NacionalidadDirector"}
                            value={values.NacionalidadDirector}
                            label={setLabel("Pais")}
                            items={Countries}
                            field={"Name"}
                            handleInputChange={handleInputChange}
                            className={classNames({ "p-invalid": showMessages?.NacionalidadDirector })}
                            enable={editable}
                          />
                        </div>

                        {/* Identificacion Director*/}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.Posicion}
                              onChange={(e) =>
                                handleInputChange(e, "Posicion")
                              }
                              className={classNames({
                                "p-invalid": showMessages?.Posicion,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("Posición")}</label>
                          </div>
                        </div>

                        {/* Email */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.EmailDirector}
                              onChange={(e) =>
                                handleInputChange(e, "EmailDirector")
                              }
                              className={classNames({
                                "p-invalid": showMessages?.EmailDirector,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("Email")}</label>
                          </div>
                        </div>

                        <div className="mt-3">
                          <Button
                            icon="pi pi-plus"
                            type="button"
                            disabled={!editable}
                            tooltip={setLabel("Agregar Director")}
                            tooltipOptions={{ className: "purple-tooltip", position: "top" }}
                            onClick={agregarDirectores}
                          />
                        </div>
                      </div>
                      {/* MENSAJES DE ERROR */}
                      {showMessages.ErrorDirectores && (
                        <div className="p-error">
                          {setLabel("completarCamposObligatorios")}
                        </div>
                      )}

                      {/* Lista de accionistas */}
                      <div
                        style={{ width: '50%' }}
                        className="mx-3 mb-3"
                      >
                        <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: "250px" }}>
                          {listadoDirectores?.length > 0 && (
                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                              <thead style={{ backgroundColor: "#4CAF50", color: "black" }}>
                                <tr>
                                  <th style={{ padding: "8px", border: "1px solid #ddd", width: "30%" }}>
                                    <div className="p-2">
                                      {setLabel("Nombre")}
                                    </div>
                                  </th>
                                  <th style={{ padding: "8px", border: "1px solid #ddd", width: "20%" }}>
                                    <div className="p-2">
                                      {setLabel("Identificacion")}
                                    </div>
                                  </th>
                                  <th style={{ padding: "8px", border: "1px solid #ddd", width: "15%" }}>
                                    <div className="p-2">
                                      {setLabel("Nacionalidad")}
                                    </div>
                                  </th>
                                  <th style={{ padding: "8px", border: "1px solid #ddd", width: "20%" }}>
                                    <div className="p-2">
                                      {setLabel("Posicion")}
                                    </div>
                                  </th>
                                  <th style={{ padding: "8px", border: "1px solid #ddd", width: "15%" }}>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {listadoDirectores.map((director, index) => (
                                  <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                                    <td style={{ padding: "8px", border: "1px solid #ddd", width: "25%" }}>
                                      {director.NombreDirector}
                                    </td>
                                    <td style={{ padding: "8px", border: "1px solid #ddd", width: "25%" }}>
                                      {director.IdentificacionDirector}
                                    </td>
                                    <td style={{ padding: "8px", border: "1px solid #ddd", width: "15%" }}>
                                      {director.NacionalidadDirector}
                                    </td>
                                    <td style={{ padding: "8px", border: "1px solid #ddd", width: "20%" }}>
                                      {director.Posicion}
                                    </td>
                                    <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center", width: "15%" }}>
                                      <button
                                        onClick={() => editarDirector(director.Id)}
                                        disabled={!editable}
                                        style={{ backgroundColor: "transparent", border: "none", padding: "0", cursor: "pointer", marginRight: "10px" }} // Agregar margen derecho
                                      >
                                        <i className="pi pi-pencil"></i>
                                      </button>

                                      <button
                                        onClick={() => eliminarDirector(director.Id)}
                                        disabled={!editable}
                                        style={{ backgroundColor: "transparent", border: "none", padding: "0", cursor: "pointer" }}
                                      >
                                        <i className="pi pi-trash"></i>
                                      </button>
                                    </td>

                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </div>
                    </div>
                  }
                />
              )}


              {/* INFORMACION DE CONTACTO CUENTAS POR PAGAR */}
              <Card
                // titulo={setLabel("inforamcionContactoCuentasPagar")}
                titulo={
                  <h2 style={{ fontSize: "18px", fontWeight: "bold" }}>
                    {setLabel("inforamcionContactoCuentasPagar")}
                  </h2>
                }
                contenido={
                  <div>
                    <div className="inputsProveedorContainer">
                      {/* Contacto de cuentas por cobrar (Nombre) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.ContactoCuentasPorPagar}
                            onChange={(e) =>
                              handleInputChange(e, "ContactoCuentasPorPagar")
                            }
                            className={classNames({
                              "p-invalid": showMessages?.ContactoCuentasPorPagar,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("Nombre")}</label>
                        </div>
                      </div>

                      {/* Correo electrónico (cuentas por cobrar) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.CorreoCuentasPorPagar}
                            onChange={(e) =>
                              handleInputChange(e, "CorreoCuentasPorPagar")
                            }
                            className={classNames({
                              "p-invalid": showMessages?.CorreoCuentasPorPagar,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("Email")}</label>
                        </div>
                      </div>

                      {/* Número de teléfono */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.TelefonoCuentasPorPagar}
                            onChange={(e) =>
                              handleInputChange(e, "TelefonoCuentasPorPagar")
                            }
                            className={classNames({
                              "p-invalid": showMessages?.TelefonoCuentasPorPagar,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("numeroTelefono")}</label>
                        </div>
                      </div>
                    </div>
                    {/* MENSAJES DE ERROR */}
                    {showMessages.CuentasPorCobrar && (
                      <div className="p-error">
                        {setLabel("completarCamposObligatorios")}
                      </div>
                    )}
                  </div>
                }
              />

              {/* INFORMACION DE CONTACTO FINANZAS */}
              <Card
                // titulo={setLabel("inforamcionContactoFinanzas")}
                titulo={
                  <h2 style={{ fontSize: "18px", fontWeight: "bold" }}>
                    {setLabel("inforamcionContactoFinanzas")}
                  </h2>
                }
                contenido={
                  <div className={config.theme === "Dark" ? "texto-blanco" : ""}>
                    {/* <div>{setLabel("Contacto")} 1</div> */}
                    <div className="inputsProveedorContainer">
                      {/* Contacto de cuentas por cobrar (Nombre) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.NombreContactoFin1}
                            onChange={(e) =>
                              handleInputChange(e, "NombreContactoFin1")
                            }
                            className={classNames({
                              "p-invalid": showMessages?.NombreContactoFin1,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("Nombre")}</label>
                        </div>
                      </div>

                      {/* Correo electrónico (cuentas por cobrar) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.CorreoContactoFin1}
                            onChange={(e) =>
                              handleInputChange(e, "CorreoContactoFin1")
                            }
                            className={classNames({
                              "p-invalid": showMessages?.CorreoContactoFin1,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("Email")}</label>
                        </div>
                      </div>

                      {/* Número de teléfono */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.TelefonoContactoFin1}
                            onChange={(e) =>
                              handleInputChange(e, "TelefonoContactoFin1")
                            }
                            className={classNames({
                              "p-invalid": showMessages?.TelefonoContactoFin1,
                            })}
                            disabled={!editable}
                          />
                          <label>{setLabel("numeroTelefono")}</label>
                        </div>
                      </div>
                    </div>

                    {/* MENSAJES DE ERROR */}
                    {showMessages.ConcactoFinanzas && (
                      <div className="p-error">
                        {setLabel("completarCamposObligatorios")}
                      </div>
                    )}
                  </div>
                }
              />

              {/* REFERENCIAS COMERCIALES */}
              {habilitarCredito && (
                <Card
                  // titulo={setLabel("referenciasComerciales")}
                  titulo={
                    <h2 style={{ fontSize: "18px", fontWeight: "bold" }}>
                      {setLabel("referenciasComerciales")}
                    </h2>
                  }
                  contenido={
                    <div className={config.theme === "Dark" ? "texto-blanco" : ""}>
                      {/* NOMBRE COMPAñIA 1 */}
                      <div className="seccionText">
                        <span>{setLabel("Referencia")} 1:</span>
                      </div>

                      <div className="inputsProveedorContainer">

                        {/* Nombre Compañía */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.CompanyRefComercial1}
                              onChange={(e) => handleInputChange(e, "CompanyRefComercial1")}
                              className={classNames({
                                "p-invalid": showMessages?.CompanyRefComercial1,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("CompanyRefComercial")}</label>
                          </div>
                        </div>

                        {/* Nombre Contacto */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.RefNombre1}
                              onChange={(e) => handleInputChange(e, "RefNombre1")}
                              className={classNames({
                                "p-invalid": showMessages?.RefNombre1,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("nombreContacto1")}</label>
                          </div>
                        </div>
                        {/* Telefono */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.RefTelefono1}
                              onChange={(e) => handleInputChange(e, "RefTelefono1")}
                              className={classNames({
                                "p-invalid": showMessages?.RefTelefono1,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("numeroTelefono")}</label>
                          </div>
                        </div>
                        {/* Correo */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.RefCorreo1}
                              onChange={(e) => handleInputChange(e, "RefCorreo1")}
                              className={classNames({
                                "p-invalid": showMessages?.RefCorreo1,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("Email")}</label>
                          </div>
                        </div>
                      </div>

                      {/* Archivo */}

                      <div>
                        <div style={{ minHeight: 'auto', marginLeft: '12px' }}>
                          <label for="formFile" className="form-label">
                            {setLabel("RefLoad")}:
                          </label>
                        </div>
                        <div className="mb-3" style={{ minHeight: 'auto', marginLeft: '12px' }}>
                          <FileUpload
                            ref={fileUpload}
                            name="demo"
                            url="./upload"
                            customUpload
                            uploadHandler={subirFileRefComercial1}
                            required
                            auto
                            maxFileSize={5242880} //EQUIVALENTE A 5 MB
                            disabled={!editable}
                          />
                          {showMessages?.FileRefComercial1 && (
                            <small className="p-error">
                              Por favor, agregue un archivo.
                            </small>
                          )}
                          <div className="mt-3">
                            <div>
                              {listadoArchivoRefComercial1?.map((a, i) => (
                                <div
                                  className="d-flex gap p-2 border mt-2"
                                  style={{ alignItems: "center" }}
                                  key={i}
                                >
                                  <div className="col-9">{a}</div>
                                  <Button
                                    icon="pi pi-download"
                                    onClick={() => descargarRefComercial1(a)}
                                    disabled={!editable}
                                  />
                                  <Button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    onClick={() => eliminarRefComercial1(a)}
                                    disabled={!editable}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="seccionText">
                        <span>{setLabel("Referencia")} 2:</span>
                      </div>

                      <div className="inputsProveedorContainer">

                        {/* Nombre Compañía */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.CompanyRefComercial2}
                              onChange={(e) => handleInputChange(e, "CompanyRefComercial2")}
                              className={classNames({
                                "p-invalid": showMessages?.CompanyRefComercial2,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("CompanyRefComercial")}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.RefNombre2}
                              onChange={(e) => handleInputChange(e, "RefNombre2")}
                              className={classNames({
                                "p-invalid": showMessages?.RefNombre2,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("nombreContacto1")}</label>
                          </div>
                        </div>
                        {/* Telefono */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.RefTelefono2}
                              onChange={(e) => handleInputChange(e, "RefTelefono2")}
                              className={classNames({
                                "p-invalid": showMessages?.RefTelefono2,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("numeroTelefono")}</label>
                          </div>
                        </div>
                        {/* Correo */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.RefCorreo2}
                              onChange={(e) => handleInputChange(e, "RefCorreo2")}
                              className={classNames({
                                "p-invalid": showMessages?.RefCorreo2,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("Email")}</label>
                          </div>
                        </div>
                      </div>
                      {/* Archivo */}
                      <div>
                        <div>
                          <div>
                            <label for="formFile" className="form-label" style={{ minHeight: 'auto', marginLeft: '12px' }}>
                              {setLabel("RefLoad")}:
                            </label>
                          </div>
                          <div className="mb-3" style={{ minHeight: 'auto', marginLeft: '12px' }}>
                            <FileUpload
                              ref={fileUpload}
                              name="demo"
                              url="./upload"
                              customUpload
                              uploadHandler={subirFileRefComercial2}
                              required
                              auto
                              maxFileSize={5242880} //EQUIVALENTE A 5 MB
                              disabled={!editable}
                            />
                            {showMessages?.FileRefComercial2 && (
                              <small className="p-error">
                                Por favor, agregue un archivo.
                              </small>
                            )}
                            <div className="mt-3">
                              <div>
                                {listadoArchivoRefComercial2?.map((a, i) => (
                                  <div
                                    className="d-flex gap p-2 border mt-2"
                                    style={{ alignItems: "center" }}
                                    key={i}
                                  >
                                    <div className="col-9">{a}</div>
                                    <Button
                                      icon="pi pi-download"
                                      onClick={() => descargarRefComercial2(a)}
                                      disabled={!editable}
                                    />
                                    <Button
                                      icon="pi pi-trash"
                                      severity="danger"
                                      onClick={() => eliminarRefComercial2(a)}
                                      disabled={!editable}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>



                      {/* MENSAJES DE ERROR */}
                      {showMessages.ReferenciasComerciales && (
                        <div className="p-error">
                          {setLabel("completarCamposObligatorios")}
                        </div>
                      )}
                    </div>
                  }
                />
              )}

              {/* REFERENCIAS BANCARIAS */}
              {habilitarCredito && (
                <Card
                  // titulo={setLabel("referenciasBancarias")}
                  titulo={
                    <h2 style={{ fontSize: "18px", fontWeight: "bold" }}>
                      {setLabel("referenciasBancarias")}
                    </h2>
                  }

                  contenido={
                    <div className={config.theme === "Dark" ? "texto-blanco" : ""}>
                      {/* NOMBRE COMPAñIA 1 */}
                      <div className="seccionText">
                        <span>{setLabel("Referencia")} 1:</span>
                      </div>

                      <div className="inputsProveedorContainer">

                        {/* Nombre Banco */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.BankName1}
                              onChange={(e) => handleInputChange(e, "BankName1")}
                              className={classNames({
                                "p-invalid": showMessages?.BankName1,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("BankName")}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.NombreRefBancaria1}
                              onChange={(e) => handleInputChange(e, "NombreRefBancaria1")}
                              className={classNames({
                                "p-invalid": showMessages?.NombreRefBancaria1,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("nombreContacto1")}</label>
                          </div>
                        </div>
                        {/* Telefono */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.TelefonoRefBancaria1}
                              onChange={(e) => handleInputChange(e, "TelefonoRefBancaria1")}
                              className={classNames({
                                "p-invalid": showMessages?.TelefonoRefBancaria1,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("numeroTelefono")}</label>
                          </div>
                        </div>
                        {/* Correo */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.CorreoRefBancaria1}
                              onChange={(e) => handleInputChange(e, "CorreoRefBancaria1")}
                              className={classNames({
                                "p-invalid": showMessages?.CorreoRefBancaria1,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("Email")}</label>
                          </div>
                        </div>
                      </div>

                      {/* Archivo Bancarias 1*/}

                      <div style={{ minHeight: 'auto', marginLeft: '12px' }}>
                        <div>
                          <label for="formFile" className="form-label">
                            {setLabel("RefLoad")}:
                          </label>
                        </div>
                        {/* Archovo Ref Banc 1 */}
                        <div className="mb-3">
                          <FileUpload
                            ref={fileUpload}
                            name="demo"
                            url="./upload"
                            customUpload
                            uploadHandler={subirFileRefBanc1}
                            required
                            auto
                            maxFileSize={5242880} //EQUIVALENTE A 5 MB
                            disabled={!editable}
                          />
                          {showMessages?.FileRefBanc1 && (
                            <small className="p-error">
                              Por favor, agregue un archivo.
                            </small>
                          )}
                          <div className="mt-3">
                            <div>
                              {listadoArchivoRefBanc1?.map((a, i) => (
                                <div
                                  className="d-flex gap p-2 border mt-2"
                                  style={{ alignItems: "center" }}
                                  key={i}
                                >
                                  <div className="col-9">{a}</div>
                                  <Button
                                    icon="pi pi-download"
                                    onClick={() => descargarRefBanc1(a)}
                                    disabled={!editable}
                                  />
                                  <Button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    onClick={() => eliminarRefBanc1(a)}
                                    disabled={!editable}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="seccionText">
                        <span>{setLabel("Referencia")} 2:</span>
                      </div>

                      <div className="inputsProveedorContainer">


                        {/* Nombre Banco */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.BankName2}
                              onChange={(e) => handleInputChange(e, "BankName2")}
                              className={classNames({
                                "p-invalid": showMessages?.BankName2,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("BankName")}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.NombreRefBancaria2}
                              onChange={(e) => handleInputChange(e, "NombreRefBancaria2")}
                              className={classNames({
                                "p-invalid": showMessages?.NombreRefBancaria2,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("nombreContacto1")}</label>
                          </div>
                        </div>
                        {/* Telefono */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.TelefonoRefBancaria2}
                              onChange={(e) => handleInputChange(e, "TelefonoRefBancaria2")}
                              className={classNames({
                                "p-invalid": showMessages?.TelefonoRefBancaria2,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("numeroTelefono")}</label>
                          </div>
                        </div>
                        {/* Correo */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.CorreoRefBancaria2}
                              onChange={(e) => handleInputChange(e, "CorreoRefBancaria2")}
                              className={classNames({
                                "p-invalid": showMessages?.CorreoRefBancaria2,
                              })}
                              disabled={!editable}
                            />
                            <label>{setLabel("Email")}</label>
                          </div>
                        </div>
                      </div>

                      {/* Archivo Bancarias 2*/}

                      <div style={{ minHeight: 'auto', marginLeft: '12px' }}>
                        <div>
                          <label for="formFile" className="form-label">
                            {setLabel("RefLoad")}:
                          </label>
                        </div>
                        <div className="mb-3">
                          <FileUpload
                            ref={fileUpload}
                            name="demo"
                            url="./upload"
                            customUpload
                            uploadHandler={subirFileRefBanc2}
                            required
                            auto
                            maxFileSize={5242880} //EQUIVALENTE A 5 MB
                            disabled={!editable}
                          />
                          {showMessages?.FileRefBanc2 && (
                            <small className="p-error">
                              Por favor, agregue un archivo.
                            </small>
                          )}
                          <div className="mt-3">
                            <div>
                              {listadoArchivoRefBanc2?.map((a, i) => (
                                <div
                                  className="d-flex gap p-2 border mt-2"
                                  style={{ alignItems: "center" }}
                                  key={i}
                                >
                                  <div className="col-9">{a}</div>
                                  <Button
                                    icon="pi pi-download"
                                    onClick={() => descargarRefBanc2(a)}
                                    disabled={!editable}
                                  />
                                  <Button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    onClick={() => eliminarRefBanc2(a)}
                                    disabled={!editable}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>


                      {/* MENSAJES DE ERROR */}
                      {showMessages.ReferenciasComerciales && (
                        <div className="p-error">
                          {setLabel("completarCamposObligatorios")}
                        </div>
                      )}
                    </div>
                  }
                />
              )}




              {/* DOCUMENTACION */}
              <Card
                // titulo={setLabel("Documentation")}
                titulo={
                  <h2 style={{ fontSize: "18px", fontWeight: "bold" }}>
                    {setLabel("Documentation")}
                  </h2>
                }
                contenido={
                  <div className={config.theme === "Dark" ? "texto-blanco" : ""} style={{ minHeight: 'auto', marginLeft: '12px' }}>
                    <div className="seccionText">
                      <span>{setLabel("adjuntarDocumentos")}</span>
                    </div>
                    <div className="">

                      {/* {values.CodigoCliente !== null && ( )} */}
                      <div>
                        <div>
                          {/* {(ArchivoBIC?.name ? ArchivoBIC.name : '')} */}
                          <div>
                            <label for="formFile" className="form-label">
                              <strong >BIC:</strong> RTN/NIT/RUC/TAX ID
                            </label>
                          </div>
                          <div className="mb-3">
                            <FileUpload
                              ref={fileUpload}
                              name="demo"
                              url="./upload"
                              customUpload
                              uploadHandler={subirFileBIC}
                              required
                              auto
                              maxFileSize={5242880} //EQUIVALENTE A 5 MB
                              disabled={!editable}
                            />
                            {showMessages?.FileBIC && (
                              <small className="p-error">
                                Por favor, seleccione un archivo BIC.
                              </small>
                            )}
                            <div className="mt-3">
                              <div>
                                {listadoArchivos?.map((a, i) => (
                                  <div
                                    className="d-flex gap p-2 border mt-2"
                                    style={{ alignItems: "center" }}
                                    key={i}
                                  >
                                    <div className="col-9">{a}</div>
                                    <Button
                                      icon="pi pi-download"
                                      onClick={() => getArchivo(a)}
                                      disabled={!editable}
                                    />
                                    <Button
                                      icon="pi pi-trash"
                                      severity="danger"
                                      onClick={() => eliminar(a)}
                                      disabled={!editable}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* FACTURA */}
                      {habilitarCredito && (
                        <div className="mb-3">
                          <div>
                            <label for="formFile" className="form-label">
                              <strong>{setLabel("Factura")}:</strong>
                            </label>
                          </div>
                          {/* {values.FacturaName && <p>{setLabel('ArchivoActual')}: <span className='link' onClick={() => getArchivo(values.FacturaName)}>{values.FacturaName}</span></p>} */}
                          <FileUpload
                            ref={fileUpload}
                            name="demo"
                            url="./upload"
                            multiple
                            customUpload
                            uploadHandler={subirFileFactura}
                            // className={classNames('form-control p-inputtext p-component', { 'p-invalid': showMessages?.resultArchivoFactura })}
                            required
                            auto
                            maxFileSize={5242880} //EQUIVALENTE A 5 MB
                            disabled={!editable}
                          />
                          {showMessages?.FileFactura && (
                            <small className="p-error">
                              Por favor, agregue una Factura.
                            </small>
                          )}

                          <div>
                            {listadoArchivosFactura?.map((a, i) => (
                              <div
                                className="d-flex gap p-2 border mt-2"
                                style={{ alignItems: "center" }}
                                key={i}
                              >
                                <div className="col-9">{a}</div>
                                <Button
                                  icon="pi pi-download"
                                  onClick={() => getArchivoFactura(a)}
                                  disabled={!editable}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  severity="danger"
                                  onClick={() => eliminarFactura(a)}
                                  disabled={!editable}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* ESTADOS FINANCIEROS */}
                      {habilitarCredito && (
                        <div className="mb-3">
                          <label for="formFile" className="form-label">
                            <strong>{setLabel("EstadoF")}:</strong>
                          </label>
                          {/* {values.FacturaName && <p>{setLabel('ArchivoActual')}: <span className='link' onClick={() => getArchivo(values.FacturaName)}>{values.FacturaName}</span></p>} */}
                          <FileUpload
                            ref={fileUpload}
                            name="demo"
                            url="./upload"
                            multiple
                            customUpload
                            uploadHandler={subirFileEstados}
                            required
                            auto
                            maxFileSize={5242880} //EQUIVALENTE A 5 MB
                            disabled={!editable}
                          />
                          {showMessages?.FileEstadosFinancieros && (
                            <small className="p-error">
                              Por favor, agregue una Estado Financiero.
                            </small>
                          )}

                          <div>
                            {listadoArchivosEstados?.map((a, i) => (
                              <div
                                className="d-flex gap p-2 border mt-2"
                                style={{ alignItems: "center" }}
                                key={i}
                              >
                                <div className="col-9">{a}</div>
                                <Button
                                  icon="pi pi-download"
                                  onClick={() => getArchivoEstados(a)}
                                  disabled={!editable}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  severity="danger"
                                  onClick={() => eliminarEstados(a)}
                                  disabled={!editable}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* PERMISO DE OPERACIONES */}
                      {/* {values?.Country?.Id === IdHonduras && ()} */}
                      <div>
                        <div>
                          <div className="mb-3">
                            <label for="formFile" className="form-label">
                              <strong>{setLabel("PermisoOperaciones")}:</strong>
                            </label>
                            <FileUpload
                              ref={fileUpload}
                              name="demo"
                              url="./upload"
                              multiple
                              customUpload
                              uploadHandler={subirFilePermiso}
                              className={classNames(
                                "form-control p-inputtext p-component",
                                {
                                  "p-invalid":
                                    showMessages?.FilePermisoOpera,
                                }
                              )}
                              auto
                              maxFileSize={5242880} //EQUIVALENTE A 5 MB
                              disabled={!editable}
                            />
                            {showMessages?.FilePermisoOpera && (
                              <small className="p-error">
                                Por favor, agregue un Permiso de Operaciones.
                              </small>
                            )}
                            <div>
                              {listadoArchivosPermiso?.map((a, i) => (
                                <div
                                  className="d-flex gap p-2 border mt-2"
                                  style={{ alignItems: "center" }}
                                  key={i}
                                >
                                  <div className="col-9">{a}</div>
                                  <Button
                                    icon="pi pi-download"
                                    onClick={() => getArchivoPermiso(a)}
                                    disabled={!editable}
                                  />
                                  <Button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    onClick={() => eliminarPermiso(a)}
                                    disabled={!editable}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>


                      {/* Escritura Constitucion */}
                      {habilitarCredito && (
                        <div>
                          <div>
                            <div className="mb-3">
                              <label for="formFile" className="form-label">
                                <strong>
                                  {setLabel("escrituraConstitucion")}:
                                </strong>
                              </label>
                              <FileUpload
                                ref={fileUpload}
                                name="demo"
                                url="./upload"
                                multiple
                                customUpload
                                uploadHandler={subirFileEscritura}
                                className={classNames(
                                  "form-control p-inputtext p-component",
                                  {
                                    "p-invalid":
                                      showMessages?.FileConstitucion,
                                  }
                                )}
                                required
                                auto
                                maxFileSize={5242880} //EQUIVALENTE A 5 MB
                                disabled={!editable}
                              />
                              {showMessages?.FileConstitucion && (
                                <small className="p-error">
                                  Por favor, agregue la Escritura de Constitucion.
                                </small>
                              )}

                              {listadoArchivosEscritura?.map((a, i) => (
                                <div
                                  className="d-flex gap p-2 border mt-2"
                                  style={{ alignItems: "center" }}
                                  key={i}
                                >
                                  <div className="col-9">{a}</div>
                                  <Button
                                    icon="pi pi-download"
                                    onClick={() => getArchivoEscritura(a)}
                                    disabled={!editable}
                                  />
                                  <Button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    onClick={() => eliminarEscritura(a)}
                                    disabled={!editable}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}


                      {/* CUMPLIMIENTO AMBIENTAL */}
                      {habilitarCredito && (
                        <div className="mb-3">
                          <div>
                            <label for="formFile" className="form-label">
                              <strong>{setLabel("CertificadoAmbiental")}:</strong>
                            </label>
                          </div>
                          <FileUpload
                            ref={fileUpload}
                            name="demo"
                            url="./upload"
                            multiple
                            customUpload
                            uploadHandler={subirFileCerificadoA}
                            required
                            auto
                            maxFileSize={5242880} //EQUIVALENTE A 5 MB
                            disabled={!editable}
                          />
                          {showMessages?.FileCertificadoAmbiental && (
                            <small className="p-error">
                              Por favor, agregue un archivo.
                            </small>
                          )}

                          <div>
                            {listadoArchivoCertificadoA?.map((a, i) => (
                              <div
                                className="d-flex gap p-2 border mt-2"
                                style={{ alignItems: "center" }}
                                key={i}
                              >
                                <div className="col-9">{a}</div>
                                <Button
                                  icon="pi pi-download"
                                  onClick={() => descargarCertificadoA(a)}
                                  disabled={!editable}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  severity="danger"
                                  onClick={() => eliminarCertificadoA(a)}
                                  disabled={!editable}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* CUMPLIMIENTO AMBIENTAL */}
                      {habilitarCredito && (
                        <div className="mb-3">
                          <div>
                            <label for="formFile" className="form-label">
                              <strong>{setLabel("CertificadoLaboral")}:</strong>
                            </label>
                          </div>
                          <FileUpload
                            ref={fileUpload}
                            name="demo"
                            url="./upload"
                            multiple
                            customUpload
                            uploadHandler={subirFileCerificadoL}
                            required
                            auto
                            maxFileSize={5242880} //EQUIVALENTE A 5 MB
                            disabled={!editable}
                          />
                          {showMessages?.FileCertificadoLaboral && (
                            <small className="p-error">
                              Por favor, agregue un archivo.
                            </small>
                          )}

                          <div>
                            {listadoArchivoCertificadoL?.map((a, i) => (
                              <div
                                className="d-flex gap p-2 border mt-2"
                                style={{ alignItems: "center" }}
                                key={i}
                              >
                                <div className="col-9">{a}</div>
                                <Button
                                  icon="pi pi-download"
                                  onClick={() => descargarCertificadoL(a)}
                                  disabled={!editable}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  severity="danger"
                                  onClick={() => eliminarCertificadoL(a)}
                                  disabled={!editable}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}


                      {/* ARCHIVO NACIONAL */}
                      {values?.Country?.Id === IdHonduras && (
                        <div>
                          <div className="d-flex align-items-center mb-2">
                            <label className="mx-3" htmlFor="FileNacional">
                              <strong>{setLabel("zonaLibre")}:</strong>
                            </label>
                            <label
                              className={classNames("mx-3", {
                                "fw-bold": ArchivoSelected === 0,
                              })}
                              htmlFor="FileNacional"
                            >
                              {setLabel("no")}
                            </label>
                            <InputSwitch
                              checked={ArchivoSelected === 1}
                              onChange={() => {
                                ArchivoSelected === 1
                                  ? setArchivoSelected(0)
                                  : setArchivoSelected(1);

                                verificarCampos(false, false, true)
                              }}
                              disabled={!editable}
                            />
                            {/* <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} /> */}
                            <label
                              className={classNames("mx-3", {
                                "fw-bold": ArchivoSelected === 1,
                              })}
                              htmlFor="FileNacional"
                            >
                              {setLabel("si")}
                            </label>
                          </div>

                          {ArchivoSelected === 1 && (
                            <div className="inputsProveedorContainer">
                              {/* NOMBRE ZONA */}
                              <div>
                                <div className="p-float-label">
                                  <InputText
                                    value={values.NombreZonaLibre}
                                    onChange={(e) =>
                                      handleInputChange(e, "NombreZonaLibre")
                                    }
                                    className={classNames({
                                      "p-invalid":
                                        showMessages?.NombreZonaLibre,
                                    })}
                                    disabled={!editable}
                                  />
                                  <label>{setLabel("nombreZona")}</label>
                                </div>
                              </div>

                              {/* DIRECCION ZONA */}
                              <div>
                                <div className="p-float-label">
                                  <InputText
                                    value={values.DireccionZonaLibre}
                                    onChange={(e) =>
                                      handleInputChange(e, "DireccionZonaLibre")
                                    }
                                    className={classNames({
                                      "p-invalid":
                                        showMessages?.DireccionZonaLibre,
                                    })}
                                    disabled={!editable}
                                  />
                                  <label>{setLabel("direccionZona")}</label>
                                </div>
                              </div>
                            </div>
                          )}

                          <div>
                            {ArchivoSelected === 0 ? (
                              null
                            ) : (
                              <div className="mb-3">
                                <label for="formFile" className="form-label">
                                  <strong>
                                    {setLabel("registroExonerado")}:
                                  </strong>
                                </label>
                                <FileUpload
                                  ref={fileUpload}
                                  name="demo"
                                  url="./upload"
                                  multiple
                                  customUpload
                                  uploadHandler={subirFileRegistro}
                                  className={classNames(
                                    "form-control p-inputtext p-component",
                                    {
                                      "p-invalid":
                                        showMessages?.FileRegistroExonerado,
                                    }
                                  )}
                                  required
                                  auto
                                  maxFileSize={5242880} //EQUIVALENTE A 5 MB
                                  disabled={!editable}
                                />
                                {showMessages?.FileRegistroExonerado && (
                                  <small className="p-error">
                                    Por favor, agregue Registro Exonerado.
                                  </small>
                                )}
                                {listadoArchivosRegistro?.map((a, i) => (
                                  <div
                                    className="d-flex gap p-2 border mt-2"
                                    style={{ alignItems: "center" }}
                                    key={i}
                                  >
                                    <div className="col-9">{a}</div>
                                    <Button
                                      icon="pi pi-download"
                                      onClick={() => getArchivoRegistro(a)}
                                      disabled={!editable}
                                    />
                                    <Button
                                      icon="pi pi-trash"
                                      severity="danger"
                                      onClick={() => eliminarRegistro(a)}
                                      disabled={!editable}
                                    />
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                    </div>
                    {/* MENSAJES DE ERROR */}
                    {showMessages.Documentos && !showMessages.size && (
                      <div className="p-error">
                        {setLabel("completarCamposObligatorios")}
                      </div>
                    )}
                    {showMessages.Documentos && (
                      <div className="p-error">
                        {setLabel("ErrorArchivoTamaño")}
                      </div>
                    )}
                  </div>

                }
              />
            </div>

            {/* AUTORIZACION */}
            <div className={config.theme === "Dark" ? "texto-blanco m-4" : "m-4"}>
              <div>
                <div className='d-flex align-items-center mb-3'>
                  <Checkbox
                    required={true}
                    checked={values.Autorizacion}
                    onChange={(e) => handleInputChange(e, 'Autorizacion')}
                    className={classNames('mx-3', { 'p-invalid': showMessages?.Autorizacion })}
                    disabled={!editable}
                  />
                  <span>
                    {setLabel('autorizacionPagos')}
                  </span>
                </div>
                {/* MENSAJES DE ERROR */}
                {showMessages.Autorizacion && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}

              </div>
              <br />

              <div style={{ marginLeft: 45 }} className='d-flex footerContainer '>
                <span>{setLabel('infCierta')}</span>
              </div>

            </div>

            <div className="d-flex justify-content-center footerContainer position-relative">

              {/* CONTENEDOR DE BOTONES CENTRADOS */}
              <div className="botonesContainer">
                <Button
                  className="m-2 p-button-success"
                  label={setLabel('guardarBorrador')}
                  icon="pi pi-save"
                  onClick={() => { verificarCampos(true) }}
                  disabled={!editable || !showMessages?.error}
                />
                {(userAuth?.idUser > 0 && values.IdRegistro > 0) && (
                  <Button
                    className='m-2 p-button-success'
                    label={setLabel('Revisar')}
                    icon='pi pi-check'
                    onClick={() => setDialogEstadoRevision(true)}
                  />
                )}
                <Button
                  className="m-2 p-button-success"
                  label={setLabel('guardar')}
                  icon="pi pi-save"
                  onClick={() => { verificarCampos(true) }}
                  disabled={!editable || showMessages?.error}
                />
                <Button
                  className="m-2 p-button-info"
                  label={setLabel('Imprimir')}
                  icon="pi pi-print"
                  onClick={(event) => {
                    let language = idioma === 'es' ? 2 : 1;
                    window.open(
                      `${process.env.REACT_APP_PUBLIC_URL}/FormatoInscripcionClientes/${values?.IdCustomer}/${Token}/${language}`,
                      values?.IdCustomer,
                      "MsgWindow",
                      "height=1200,width=1000"
                    );
                  }}
                  disabled={editable}
                />
              </div>

              {/* FORMATO DE INSCRIPCIÓN ALINEADO A LA DERECHA */}
              {
                !editable && (
                  <div style={{ minHeight: 'auto', width: '30%' }} className={config.theme === "Dark" ? "texto-blanco" : ""}>
                    <label htmlFor="formFile" className="form-label">
                      {setLabel("Formato de inscripción")}:
                    </label>
                    <FileUpload
                      ref={fileUpload}
                      name="demo"
                      url="./upload"
                      customUpload
                      uploadHandler={subirFormatoInscripcion}
                      required
                      maxFileSize={5242880}
                      disabled={editable}
                      style={{ width: '100%' }}
                      chooseLabel={setLabel("Cargar")}
                      uploadLabel={setLabel("Enviar")}
                      cancelLabel={setLabel("Cancelar")}
                    />
                    {showMessages?.FileFormatoInscripcion && (
                      <small className="p-error">Por favor, agregue un archivo.</small>
                    )}
                    <div className="mt-3">
                      {listadoArchivoFormatoInscripcion?.map((a, i) => (
                        <div
                          className="d-flex gap p-2 border mt-2"
                          style={{ alignItems: "center" }}
                          key={i}
                        >
                          <div className="col-9">{a}</div>
                          <Button
                            icon="pi pi-download"
                            onClick={() => descargarFormato(a)}
                            disabled={editable}
                          />
                          <Button
                            icon="pi pi-trash"
                            severity="danger"
                            onClick={() => eliminarFormatoInscripcion(a)}
                            disabled={editable}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )
              }
            </div>

          </div>
        </div>

        <Dialog
          visible={showDialogFinal}
          modal
          className="modal__contenedor modal__usuarios"
          style={{ width: '40%' }}
          onHide={() => setShowDialogFinal(false)}
        >

          <div className="mx-4">
            <p>{setLabel('dialogFinal')}</p>
          </div>
          <div className="d-flex flex-end">
            <Button
              label={setLabel("OK")}
              className="p-button-text"
              onClick={() => { setShowDialogFinal(false) }}
            />
          </div>
        </Dialog>

        <DialogEstadoRevisadoClientes
          visible={dialogEstadoRevision}
          hideDialog={hideDialogRevision}
          IdCliente={values?.IdCustomer}
          Token={Token}
        />

      </div>
    );
  } else {
    return (
      <div>
        <h1>{setLabel('noPermiso')}</h1>
      </div>
    )
  }
};

export default InscripcionClientes;
